import { Translations } from './types';

export const translationsFr: Translations = {
  landing: {
    signIn: 'Se connecter',
    signUp: "S'inscrire",
    hero: {
      eyebrow: 'Bienvenue',
      title: 'Préparons votre compte',
      subhead:
        "La création de votre compte Data Mission prend environ deux minutes. Voici à quoi vous attendre avant de commencer, pour que rien ne vous surprenne.",
      illustrationAlt: "Illustration d'une main branchant une prise sur un nuage",
    },
    steps: {
      stepLabel: 'Étape',
      step1Title: 'Saisissez votre adresse e-mail',
      step1Body:
        "Nous l'utiliserons comme nom d'utilisateur et y enverrons l'étape suivante. Utilisez de préférence une adresse professionnelle, car c'est ce compte qui sera associé à votre équipe.",
      step2Title: 'Validez avec un code à usage unique',
      step2Body:
        "Cherchez dans votre boîte de réception un code à six chiffres envoyé par nous, puis collez-le dans l'écran d'inscription. Quelques secondes suffisent pour confirmer que l'adresse est bien la vôtre.",
      step3Title: 'Définissez votre mot de passe',
      step3Body:
        "Choisissez un mot de passe et renseignez quelques informations de base à votre sujet. C'est le compte que vous utiliserez chaque fois que vous reviendrez.",
      step4Title: "Terminez l'intégration guidée",
      step4Body:
        "Une fois connecté, nous vous accompagnerons pour connecter votre première source et configurer votre première synchronisation, étape par étape. Aucune documentation à parcourir.",
    },
    cta: {
      headline: 'Prêt quand vous le souhaitez',
      subhead:
        "L'écran d'inscription est hébergé par Microsoft Entra. Il ressemble à une page de connexion, mais vous êtes au bon endroit.",
      signUpEmail: "S'inscrire avec un e-mail",
      signUpMicrosoft: "S'inscrire avec Microsoft",
      microsoftIconAlt: 'Logo Microsoft',
    },
    signInCard: {
      text: 'Vous avez déjà un compte ?',
      link: 'Connectez-vous plutôt ›',
    },
    footer: {
      privacyPolicy: 'Politique de confidentialité',
      termsOfUse: "Conditions d'utilisation",
    },
  },
  support: {
    title: 'Assistance',
    description: 'Obtenez de l\'aide pour Data Mission Sync, contactez votre partenaire et suivez vos demandes d\'assistance.',
    unavailable: 'L\'assistance est temporairement indisponible. Veuillez réessayer dans quelques minutes.',
    helpCenter: {
      title: 'Centre d\'aide',
      description: 'Consultez les guides et les réponses aux questions fréquentes.',
      open: 'Ouvrir le centre d\'aide',
    },
    partner: {
      title: 'Votre partenaire',
      description: 'Votre organisation est accompagnée par ce partenaire.',
      logoAlt: 'Logo de {name}',
      email: 'Courriel',
      phone: 'Téléphone',
      website: 'Site web',
      location: 'Emplacement',
    },
    visibility: {
      title: 'Visibilité',
      withPartner: 'Tous les utilisateurs de cette organisation peuvent consulter et commenter les demandes d\'assistance, y compris votre partenaire, {name}.',
      withoutPartner: 'Tous les utilisateurs de cette organisation peuvent consulter et commenter les demandes d\'assistance. Si un partenaire vous est attribué, il le peut aussi.',
    },
    status: {
      WaitingOnYou: 'En attente de votre réponse',
      WaitingOnYouTooltip: 'L\'assistance a répondu et a besoin de quelque chose de votre part. Votre réponse lui renvoie la demande.',
      Open: 'Ouverte',
      OpenTooltip: 'En attente de prise en charge par l\'équipe d\'assistance.',
      InProgress: 'En cours',
      InProgressTooltip: 'L\'équipe d\'assistance y travaille.',
      Resolved: 'Résolue',
      ResolvedTooltip: 'L\'équipe d\'assistance l\'a résolue. Ajoutez un commentaire si vous avez encore besoin d\'aide.',
      Closed: 'Fermée',
      ClosedTooltip: 'La demande est fermée. Vous pouvez toujours ajouter un commentaire.',
    },
    person: {
      you: 'Vous',
      teamMember: 'Membre de l\'équipe',
      supportTeam: 'Équipe d\'assistance',
      aiSummary: 'Résumé IA',
      supportRole: 'Assistance',
    },
    waitingBanner: {
      titleOne: 'L\'assistance attend votre réponse pour 1 demande',
      titleOther: 'L\'assistance attend votre réponse pour {count} demandes',
      body: 'Répondez pour faire avancer les choses.',
      action: 'Afficher les demandes',
    },
    tickets: {
      title: 'Demandes d\'assistance',
      description: 'Toutes les demandes ouvertes pour votre organisation, par n\'importe quel membre de votre équipe.',
      newTicket: 'Nouvelle demande',
      loading: 'Chargement des demandes...',
      loadFailed: 'Impossible de charger les demandes d\'assistance',
      emptyTitle: 'Aucune demande d\'assistance pour l\'instant',
      emptyBody: 'Ouvrez une demande lorsque vous avez besoin de l\'équipe d\'assistance, par exemple pour une synchronisation qui échoue ou une question sur votre configuration. Tous les membres de votre organisation peuvent la consulter et suivre son avancement ici.',
      tabsLabel: 'Filtrer les demandes',
      tabs: {
        open: 'Ouvertes',
        needsReply: 'Réponse attendue',
        closed: 'Fermées',
      },
      emptyTab: {
        open: 'Aucune demande ouverte. Créez une demande lorsque vous avez besoin d\'aide.',
        needsReply: 'Rien n\'attend votre réponse pour le moment.',
        closed: 'Aucune demande fermée pour l\'instant.',
      },
      previous: 'Précédent',
      next: 'Suivant',
      pageOf: 'Page {page} sur {totalPages}',
      openedBy: 'Ouverte par {name}',
      commentCount: '{count} commentaires',
      attachmentCount: '{count} fichiers',
      noActivity: 'Aucune réponse pour l\'instant',
      columns: {
        ticket: 'Demande',
        type: 'Type',
        category: 'Catégorie',
        status: 'Statut',
        lastActivity: 'Dernière activité',
      },
      noCategory: '—',
      types: {
        Support: 'Assistance',
        DataWrangler: 'Data Wrangler',
      },
    },
    newTicket: {
      title: 'Nouvelle demande d\'assistance',
      description: 'Décrivez ce pour quoi vous avez besoin d\'aide. Nous répondrons dans la demande.',
      back: 'Retour à l\'assistance',
      typeLabel: 'Type d\'aide',
      typeSupport: 'Obtenir de l\'assistance',
      typeSupportDescription: 'Une question ou un problème avec Data Mission Sync. Les bogues ne consomment jamais d\'heures.',
      typeWrangler: 'Data Wrangler',
      typeWranglerDescription: 'Une aide concrète pour votre installation, votre configuration ou vos données, avec les heures de votre organisation.',
      wranglerPartnerNote: 'Les services sont d\'abord proposés à votre partenaire, {name}.',
      wranglerHoursNote: 'Vous pouvez envoyer la demande quel que soit le solde d\'heures de votre organisation.',
      titleLabel: 'Titre',
      titlePlaceholder: 'Un bref résumé du problème',
      titleRequired: 'Le titre est obligatoire',
      titleTooLong: 'Le titre doit contenir au plus {max} caractères',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Ce qui s\'est passé, ce que vous attendiez et les étapes pour le reproduire',
      descriptionHint: 'Indiquez le nom du profil, la table et à peu près quand le problème a commencé. Les captures d\'écran et les détails d\'erreur aident le plus.',
      descriptionRequired: 'La description est obligatoire',
      attachmentsLabel: 'Pièces jointes (facultatif)',
      attachmentsHint: 'Jusqu\'à {size} par fichier.',
      attachmentsAllowedHint: 'Types de fichiers autorisés : {types}.',
      attachmentsBlockedHint: 'Ces types de fichiers ne peuvent pas être joints : {types}.',
      removeFile: 'Retirer {name}',
      submit: 'Créer la demande',
      submitting: 'Création...',
      cancel: 'Annuler',
      created: 'Demande d\'assistance créée',
      createFailed: 'Impossible de créer la demande d\'assistance',
      uploadsFailed: 'La demande a été créée, mais ces fichiers n\'ont pas pu être téléversés : {files}. Vous pouvez réessayer depuis la demande.',
    },
    coverage: {
      title: 'Qui aide pour quoi',
      supportHeading: 'Assistance Data Rodeo',
      included: 'Inclus',
      supportBugs: 'Les bogues et erreurs de Data Mission Sync. Les bogues ne consomment jamais les heures de qui que ce soit.',
      supportProduct: 'Le fonctionnement du produit et de ses fonctionnalités.',
      supportKnowledgeBase: 'La base de connaissances et la vidéothèque, incluses dans votre abonnement.',
      partnerTag: 'Votre partenaire',
      partnerSetup: 'Votre configuration et votre installation.',
      partnerProcesses: 'Vos processus métier et tout ce qui est construit autour de Data Mission Sync.',
      partnerServices: 'Les services et le travail de projet. Ils sont d\'abord proposés à votre partenaire.',
      contactPartner: 'Contacter {name}',
      wranglerHeading: 'Services Data Wrangler',
      paidHours: 'Heures payantes',
      wranglerSetup: 'Votre configuration, votre installation et vos processus autour de Data Mission Sync.',
      wranglerHandsOn: 'Une aide concrète d\'un Data Wrangler, prise sur vos heures achetées. Les heures Data Wrangler sont toujours payantes.',
      knowledgeBase: 'Parcourir la base de connaissances',
    },
    nextSteps: {
      title: 'Ce qui se passe après l\'envoi',
      aiSummary: 'Nous ajoutons un résumé IA en haut de votre demande, souvent avec des articles utiles.',
      bugs: 'Les bogues possibles sont transmis directement à notre équipe de développement.',
      partner: '{name} peut vous aider pour votre installation et votre configuration.',
      wrangler: 'Un Data Wrangler peut vous aider pour votre installation et votre configuration avec les heures de votre organisation.',
      waiting: 'Lorsque nous avons besoin de quelque chose, la demande affiche « En attente de votre réponse ».',
    },
    hours: {
      title: 'Heures Data Wrangler',
      scope: 'Pour toute votre organisation. Le temps passé sur une demande est consigné dans sa conversation.',
      available: 'Disponibles',
      spent: 'Utilisées à ce jour',
      assigned: 'Total acheté',
      value: '{hours} h',
      buy: 'Acheter des heures',
      askAdmin: 'Demandez à un administrateur d\'acheter des heures.',
      loadFailed: 'Impossible de charger les heures.',
    },
    buyHours: {
      title: 'Acheter des heures Data Wrangler',
      description: 'Choisissez un forfait. Vous finaliserez l\'achat sur une page Stripe sécurisée, et les heures seront ajoutées à votre organisation une fois le paiement effectué.',
      loading: 'Chargement des forfaits...',
      loadFailed: 'Impossible de charger les forfaits.',
      empty: 'Aucun forfait d\'heures n\'est disponible pour le moment.',
      packageHours: '{hours} heures',
      checkout: 'Passer au paiement',
      redirecting: 'Ouverture du paiement...',
      checkoutFailed: 'Impossible d\'ouvrir la page de paiement.',
      cancel: 'Annuler',
    },
    detail: {
      back: 'Retour à l\'assistance',
      loadFailed: 'Impossible de charger la demande d\'assistance',
      openedBy: 'Ouverte par',
      created: 'Créée le',
      updated: 'Dernière mise à jour',
      resolved: 'Résolue le',
      detailsTitle: 'Détails',
      statusLabel: 'Statut',
      type: 'Type d\'aide',
      resolutionCategory: 'Catégorie de résolution',
      notCategorized: 'Pas encore catégorisée',
      descriptionTitle: 'Description',
      attachmentsTitle: 'Pièces jointes',
      noAttachments: 'Aucun fichier joint.',
      addFiles: 'Ajouter des fichiers',
      uploading: 'Téléversement...',
      uploaded: 'Fichier téléversé',
      uploadFailed: 'Impossible de téléverser {name}',
      uploadedBy: 'Téléversé par {name}',
      download: 'Télécharger',
      downloadFailed: 'Impossible de télécharger le fichier',
      scanning: 'Analyse en cours',
      scanningTooltip: 'Le fichier est en cours d\'analyse antivirus et sera bientôt disponible.',
      unavailable: 'Indisponible',
      unavailableTooltip: 'Le fichier n\'a pas passé l\'analyse antivirus et ne peut pas être téléchargé.',
      conversationTitle: 'Conversation',
      replyCount: '{count} réponses · les plus récentes d\'abord',
      noComments: 'Aucun commentaire pour le moment.',
      yourTurn: 'À vous',
      yourTurnBody: 'L\'assistance attend votre réponse pour faire avancer cette demande.',
      commentLabel: 'Répondre à l\'assistance',
      commentPlaceholder: 'Rédigez une réponse à l\'équipe d\'assistance',
      commentRequired: 'Le commentaire est obligatoire',
      commentTooLong: 'Le commentaire doit contenir au plus {max} caractères',
      attachToReply: 'Joindre des fichiers',
      postComment: 'Envoyer la réponse',
      posting: 'Publication...',
      commentFailed: 'Impossible de publier le commentaire',
      showMore: 'Afficher toute la réponse',
      showLess: 'Afficher moins',
      openImage: 'Ouvrir {name} en taille réelle',
      imageViewerTitle: 'Aperçu de la pièce jointe',
      previousImage: 'Image précédente',
      nextImage: 'Image suivante',
      imageCount: '{index} sur {total}',
    },
    attachmentErrors: {
      tooLarge: '{name} dépasse {size}.',
      typeNotAllowed: '{name} n\'est pas un type de fichier autorisé.',
      nameTooLong: 'Le nom de {name} dépasse {max} caractères.',
    },
  },
  runs: {
    runStates: {
      Completed: 'Terminé',
      CompletedTooltip:
        'Synchronisation terminée avec succès. Toutes les données ont été extraites de la source et chargées dans la base de données cible.',
      Failed: 'Échoué',
      FailedTooltip:
        "La synchronisation a rencontré une erreur et n'a pas pu se terminer. Cliquez sur la ligne pour voir les détails de l'erreur.",
      Extracting: 'Extraction',
      ExtractingTooltip: 'Les données sont actuellement extraites de la table source.',
      Loading: 'Chargement',
      LoadingTooltip: 'Les données sont actuellement chargées dans la base de données cible.',
      WaitingForTargetLease: 'En attente de bail cible',
      WaitingForTargetLeaseTooltip:
        "En attente de l'acquisition d'un verrou sur la base de données cible avant de commencer le chargement.",
      WaitingForSourceCapacity: 'En attente de capacité source',
      WaitingForSourceCapacityTooltip:
        'Cet environnement Dataverse a atteint sa limite de requêtes simultanées de Data Mission Sync. Cette table démarrera dès que de la capacité se libérera.',
      Scheduled: 'Planifié',
      ScheduledTooltip:
        "L'exécution attend dans la file d'attente, probablement parce qu'une synchronisation précédente sur la table source est toujours en cours.",
      Skipped: 'Ignoré',
      SkippedTooltip:
        "La synchronisation a été ignorée et n'a pas été exécutée. Cliquez sur la ligne pour voir la raison.",
      Cancelling: 'Annulation en cours',
      CancellingTooltip: "Une demande d'annulation a été envoyée. La synchronisation s'arrêtera au prochain point de contrôle.",
      Cancelled: 'Annulé',
      CancelledTooltip:
        'La synchronisation a été annulée manuellement ou arrêtée avant de pouvoir se terminer.',
      Unknown: 'Inconnu',
      UnknownTooltip: "L'état de synchronisation est inconnu ou n'a pas pu être déterminé.",
    },
    skipReasons: {
      NoChangesDetected: 'Aucune modification détectée depuis la dernière synchronisation',
      InsufficientEntitlements: 'Droits insuffisants pour exécuter cette synchronisation',
      ObsoleteCheckpoint: 'Le point de contrôle est obsolète et une réinitialisation est requise',
      InitialSyncAlreadyCompleted:
        'La synchronisation initiale a déjà été complétée pour cette table',
      EntityNotAvailable:
        'Cette entité est présente dans les métadonnées mais n\'est pas interrogeable dans cet environnement',
    },
    syncMode: {
      Incremental: 'Incrémentale',
      Full: 'Complète',
      ResetAndFull: 'Réinitialiser et Complète',
    },
    triggerSource: {
      Manual: 'Manuel',
      Scheduled: 'Planifié',
    },
    errorDialog: {
      title: "Détails de l'erreur d'exécution",
      runId: "ID d'exécution",
      sourceTable: 'Table source',
      errorMessage: "Message d'erreur",
      errorDetail: 'Détails',
      externalErrorCode: "Code d'erreur externe",
      externalErrorMessage: "Message d'erreur externe",
      close: 'Fermer',
      unknown: 'Inconnu',
    },
    skipReasonDialog: {
      title: "Raison de l'ignorance de l'exécution",
      runId: "ID d'exécution",
      sourceTable: 'Table source',
      reason: 'Raison',
      close: 'Fermer',
      unknown: 'Inconnu',
    },
  },
  sidebar: {
    navigation: 'Navigation',
    dashboard: 'Tableau de bord',
    profiles: 'Profils',
    allRuns: 'Toutes les exécutions',
    organizationMembers: "Membres de l'organisation",
    agents: 'Agents',
    billing: 'Facturation',
    settings: 'Paramètres',
    help: 'Aide',
    support: 'Assistance',
    administration: 'Administration',
    sync: 'Sync',
    organizationSwitcher: {
      noOrganizations: 'Aucune organisation',
      organization: 'Organisation',
      organizationSingular: 'organisation',
      organizationPlural: 'organisations',
      newOrganization: 'Nouvelle organisation',
      pendingInvitations: 'Invitations en attente',
      acceptInvitation: 'Accepter l\'invitation',
    },
    userMenu: {
      settings: 'Paramètres',
      signOut: 'Se déconnecter',
    },
  },
  dashboard: {
    title: 'Tableau de bord',
    description: 'Bienvenue sur DataMission',
    profileActivity: 'Activité des profils (dernières 24 heures)',
    createNewProfile: 'Créer un nouveau profil',
    gettingStarted: {
      title: 'Démarrage',
      description: 'Créez votre premier profil pour commencer à synchroniser les données',
      createButton: 'Créer votre premier profil',
    },
    alerts: {
      title: 'Alertes',
      loading: 'Chargement...',
      incompleteProfile: 'Configuration de profil incomplète',
      profileMissing: 'Profil',
      isMissing: 'manque :',
      sourceConfiguration: 'Configuration de la source',
      targetConfiguration: 'Configuration de la cible',
      completeSetup: 'Terminer la configuration',
    },
    entitlements: {
      title: "Aperçu de l'organisation",
      loading: 'Chargement...',
      profiles: 'Profils',
      activeAvailable: 'Actifs / Disponibles',
      freeTrial: 'Essai gratuit',
      active: 'Actif',
      inactive: 'Inactif',
      expires: 'Expire',
      notAvailable: 'N/D',
      noActiveSubscription: 'Aucun abonnement actif ou essai gratuit',
      contactSupport: 'Veuillez contacter le support pour activer votre abonnement',
    },
    runSummary: {
      last24Hours: 'Dernières 24 heures',
      table: 'table',
      tables: 'tables',
      noTablesConfigured: 'Aucune table configurée',
      sourceTables: 'Tables sources :',
      lastSync: 'Dernière sync :',
      nextSync: 'Prochaine sync :',
      noRecentSyncs: 'Aucune synchronisation récente',
      justNow: "À l'instant",
      minuteAgo: 'minute',
      minutesAgo: 'minutes',
      hourAgo: 'heure',
      hoursAgo: 'heures',
      dayAgo: 'jour',
      daysAgo: 'jours',
      totalRuns: 'Total des exécutions',
      successful: 'Réussies',
      failed: 'Échouées',
      inProgress: 'En cours',
      skipped: 'Ignorées',
      successRate: 'Taux de réussite',
    },
  },
  profiles: {
    title: 'Profils',
    description: 'Gérez vos profils de synchronisation de données',
    createProfile: 'Créer un profil',
    limitReached: 'Vous avez atteint le nombre maximum de profils',
    noPermission: "Vous n'avez pas la permission de créer des profils dans cette organisation",
    noProfiles: 'Aucun profil trouvé. Créez votre premier profil pour commencer.',
    table: {
      name: 'Nom',
      region: 'Région',
      lastSync: 'Dernière sync',
      nextSync: 'Prochaine sync',
      tables: 'Tables',
      status: 'Statut',
      quietTime: 'Heure calme',
      edit: 'Modifier',
      burstActive: 'Rafale active',
    },
    status: {
      enabled: 'Activé',
      disabled: 'Désactivé',
    },
    sync: {
      noRecentSyncs: 'Aucune synchronisation récente',
      justNow: "À l'instant",
      minutesAgo: 'min',
      hoursAgo: 'h',
      daysAgo: 'j',
      notScheduledDisabled: 'Non planifié (profil désactivé)',
    },
    tables: {
      noTables: 'Aucune table configurée',
      sourceTables: 'Tables sources :',
    },
    quietTime: {
      none: 'Aucune',
      schedule: 'horaire',
      schedules: 'horaires',
    },
    sourceTables: {
      title: 'Tables sources',
      description: 'Tables configurées pour la synchronisation depuis cette source',
      logicalName: 'Nom logique',
      status: 'Statut',
      initialSyncCompleted: 'Synchronisation initiale terminée',
      actions: 'Actes',
      yes: 'Oui',
      no: 'Non',
      enabled: 'Activé',
      disabled: 'Désactivé',
      enabledLabel: 'Activé',
      autoDisabled: 'Désactivé automatiquement',
      autoDisabledTitle: 'Tables désactivées automatiquement',
      autoDisabledDescription:
        "Une ou plusieurs tables ont été automatiquement désactivées en raison d'échecs persistants. Veuillez consulter l'historique des exécutions dans la section ci-dessous pour identifier et résoudre les problèmes sous-jacents avant de réactiver.",
      autoDisabledTooltip:
        "La table a été automatiquement désactivée en raison d'échecs persistants",
      notSupported: 'Non pris en charge',
      notSupportedTitle: 'Tables non prises en charge',
      notSupportedDescription:
        "Une ou plusieurs tables ne sont actuellement pas prises en charge par le moteur de synchronisation. Veuillez contacter le support pour obtenir de l'aide.",
      notSupportedTooltip: "Cette entité n'est pas prise en charge par le moteur de synchronisation",
      changeTrackingRequired: 'Suivi des modifications requis',
      changeTrackingRequiredTitle: 'Suivi des modifications requis',
      changeTrackingRequiredDescription:
        "Une ou plusieurs tables ont été désactivées automatiquement, car la source ne peut pas fournir leurs modifications tant que le suivi des modifications n'est pas activé. Pour une table de relation (plusieurs-à-plusieurs), le suivi des modifications doit être activé sur les deux tables liées. Activez-le dans le système source, puis réactivez la table.",
      changeTrackingRequiredTooltip: 'Activez le suivi des modifications dans la source (sur les deux tables liées pour une table de relation), puis réactivez cette table',
      initialSync: 'Synchronisation initiale',
      incrementalSync: 'Synchronisation incrémentale',
      inventorySync: "Synchroniser l'inventaire",
      syncMode: 'Mode de synchronisation',
      syncModeIncremental: 'Incrémentale',
      syncModeIncrementalTooltip:
        'Le suivi des modifications Dataverse ne livre que les lignes modifiées depuis la dernière synchronisation.',
      syncModeIncrementalOnTooltip:
        'Seules les lignes avec un {field} plus récent sont extraites à chaque synchronisation.',
      viaFieldLabel: 'via {field}',
      syncModeFull: 'Complète',
      syncModeFullTooltip:
        "Aucun champ de filigrane n'est disponible, donc chaque synchronisation réextrait la table entière.",
      deletions: 'Détection des suppressions',
      deletionsViaField: 'Colonne',
      deletionsViaFieldTooltip:
        "Les lignes supprimées sont détectées à l'aide de la colonne '{field}' à chaque synchronisation.",
      deletionsViaInventory: 'Inventaire',
      deletionsViaInventoryNextDate: 'le {date}',
      deletionsViaInventoryPendingInitialSync: 'en attente de la synchronisation initiale',
      deletionsViaInventoryTooltip:
        "Aucune colonne de suppression n'existe sur cette entité, donc une synchronisation d'inventaire périodique réconcilie les suppressions en comparant les clés primaires.",
      deletionsPending: 'Détection en attente',
      deletionsPendingTooltip:
        'La stratégie de suppression sera déterminée après la première synchronisation.',
      deletionsViaChangeTracking: 'Suivi des modifications',
      deletionsViaChangeTrackingTooltip:
        'Le suivi des modifications Dataverse émet les événements de suppression de manière native.',
      delete: 'Supprimer',
      noTablesConfigured: 'Aucune table source configurée pour le moment.',
      noSearchResults: 'Aucune table ne correspond à votre recherche.',
      resetAndResync: 'Réinitialiser et resynchroniser',
      viewTargetSchema: 'Voir le schéma cible',
      setParent: 'Définir la table parente',
      childOf: 'Enfant de {name}',
      parentDialogTitle: 'Définir la table parente',
      parentDialogDescription:
        "Subordonnez cette table à une autre afin qu'elle ne se synchronise qu'une fois sa table parente terminée. Choisissez Aucune pour l'exécuter indépendamment.",
      parentLabel: 'Table parente',
      parentNone: 'Aucune (exécution indépendante)',
      parentUpdateSuccess: 'Table parente mise à jour',
      deleteTitle: 'Supprimer la table source',
      deleteDescription: "La suppression d'une table source arrête les synchronisations futures.",
      deleteWarning:
        'Cela supprime la table source et arrêtera toutes les synchronisations futures.',
      confirmationLabel: 'nom de la table',
      successDeleted: 'Table source supprimée avec succès',
      successReset: 'Suppression et réinitialisation initiées avec succès',
      syncTriggeredSuccessfully: 'Synchronisation déclenchée avec succès',
      tableEnabledSuccessfully: 'Table source activée avec succès',
      tableDisabledSuccessfully: 'Table source désactivée avec succès',
      tableDisabledSyncTooltip: 'Activez la table pour lancer une synchronisation',
      initialSyncInProgressTooltip: 'La synchronisation initiale de cette table est déjà en file d’attente ou en cours',
    },
    targetSchemaDialog: {
      title: 'Schéma cible',
      availableAfterFirstSync: 'Le schéma cible est disponible une fois la première synchronisation terminée.',
      loadError: 'Échec du chargement du schéma cible. Veuillez réessayer.',
      tooLargeError: 'Le schéma de cette table est trop volumineux pour être affiché.',
      columnName: 'Colonne',
      sqlType: 'SQL Type',
      nullable: 'Nullable',
      primaryKey: 'Clé primaire',
      primaryKeyBadge: 'PK',
      close: 'Fermer',
    },
    sourceCard: {
      title: 'Source',
      description: 'Source de données pour ce profil',
      testing: 'Test en cours...',
      testConnection: 'Tester la connexion',
      delete: 'Supprimer',
      noSourceAlert:
        'Une source doit être ajoutée à ce profil pour synchroniser les données. Utilisez "Reprendre la configuration" pour configurer une source Dataverse.',
      type: 'Type',
      unknown: 'Inconnu',
      baseUrl: 'URL de base',
      copyBaseUrl: "Copier l'URL de base",
      notAvailable: 'N/D',
      created: 'Créé',
      connectionStatus: 'État de la connexion',
      success: 'Succès',
      lastTest: 'Dernier test',
      neverTested: 'Jamais testé',
      connectionSuccessful: 'Connexion réussie',
      testSuccessful: 'Test de connexion réussi',
      testFailed: 'Test de connexion échoué',
      copiedToClipboard: 'Copié dans le presse-papiers',
      failedToCopy: 'Échec de la copie',
      restApiUsage: 'Utilisation de l\'API REST',
      restApiUsageLastChecked: 'Dernière vérification',
      restApiUsageNotAvailable: 'Non disponible',
      bulkApi: 'API Bulk',
      bulkApiAvailable: 'Disponible',
      bulkApiUnavailable: 'Indisponible',
    },
    targetCard: {
      title: 'Cible',
      description: 'Cible de données pour ce profil',
      testing: 'Test en cours...',
      testConnection: 'Tester la connexion',
      delete: 'Supprimer',
      noTargetAlert:
        'Une cible doit être ajoutée à ce profil pour synchroniser les données. Utilisez "Reprendre la configuration" pour configurer une cible Azure SQL.',
      type: 'Type',
      unknown: 'Inconnu',
      server: 'Serveur',
      copyServer: 'Copier le serveur',
      database: 'Base de données',
      copyDatabase: 'Copier la base de données',
      schema: 'Schéma',
      copySchema: 'Copier le schéma',
      tablePrefix: 'Préfixe de table',
      noTablePrefix: 'Aucun',
      notAvailable: 'N/D',
      created: 'Créé',
      connectionStatus: 'État de la connexion',
      success: 'Succès',
      lastConnectionTest: 'Dernier test de connexion',
      neverTested: 'Jamais testé',
      nextSync: 'Prochaine synchronisation',
      connectionSuccessful: 'Connexion réussie',
      testSuccessful: 'Test de connexion réussi',
      testFailed: 'Test de connexion échoué',
      copiedToClipboard: 'Copié dans le presse-papiers',
      failedToCopy: 'Échec de la copie',
    },
    editDialog: {
      buttonText: 'Modifier le profil',
      title: 'Modifier le profil',
      description: 'Mettre à jour les informations du profil',
      name: 'Nom',
      namePlaceholder: 'Mon profil',
      region: 'Région',
      regionPlaceholder: 'eastus',
      cancel: 'Annuler',
      saving: 'Enregistrement...',
      save: 'Enregistrer les modifications',
      updateSuccess: 'Profil mis à jour avec succès',
      dataverseLengthsTitle: 'Longueurs des colonnes Dataverse',
      dataverseLengthsDescription:
        'Longueurs maximales des colonnes d’étiquette et de sélection multiple Dataverse. Les modifications s’appliquent lors de la prochaine réinitialisation complète et resynchronisation de chaque table.',
      lookupLabelLength: 'Étiquette de recherche',
      choiceLabelLength: 'Étiquette de choix',
      multiSelectLength: 'Sélection multiple',
      lengthReduceWarning:
        'Réduire une longueur peut tronquer les valeurs existantes lors de la prochaine réinitialisation. Récupérable en l’augmentant et en resynchronisant.',
    },
    syncSettings: {
      buttonText: 'Paramètres de synchronisation',
      title: 'Paramètres de synchronisation',
      description: 'Configurer le comportement de synchronisation pour ce profil.',
      deleteModeLabel: 'Mode de suppression',
      warningTitle: 'Avertissement : Cela peut entraîner une perte de données',
      warningDescription:
        'Changer le mode de suppression après la synchronisation initiale peut entraîner des incohérences ou des pertes de données. Les enregistrements précédemment supprimés de manière logique peuvent être définitivement supprimés, ou les enregistrements supprimés physiquement peuvent ne pas être correctement suivis.',
      acknowledgeChange: 'Je comprends que cela peut entraîner une perte de données et je souhaite continuer',
      cancel: 'Annuler',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      updateSuccess: 'Paramètres de synchronisation mis à jour avec succès',
    },
  },
  syncButton: {
    sync: 'Synchroniser',
    syncing: 'Synchronisation...',
    incrementalSync: 'Synchronisation incrémentale',
    resetAndFullSync: 'Réinitialiser + Synchronisation complète',
  },
  profileDetail: {
    outboundIp: 'IP sortante',
    status: {
      active: 'Actif',
      paused: 'En pause',
    },
    actions: {
      copyProfileId: "Copier l'ID du profil",
      help: 'Aide',
      updating: 'Mise à jour...',
      disable: 'Désactiver',
      enable: 'Activer',
      enabled: 'Activé',
      syncing: 'Synchronisation...',
      sync: 'Synchroniser',
      resetFullSync: 'Réinitialiser + Synchronisation complète',
      triggerInitialSync: 'Déclencher la synchronisation initiale',
      resumeSetup: 'Reprendre la configuration',
      editProfile: 'Modifier le profil',
      deleteProfile: 'Supprimer le profil',
      actions: 'Actes',
      syncDisabledTooltip: 'Activez le profil pour lancer une synchronisation',
    },
    quietTime: {
      title: 'Périodes de temps calme',
      description: 'Les synchronisations seront ignorées pendant ces fenêtres de temps',
      addQuietTimeBlock: 'Ajouter un bloc de temps calme',
      loadingSchedules: 'Chargement des horaires...',
      noSchedules: 'Aucun horaire de temps calme configuré',
      recurrence: 'Récurrence',
      startTime: 'Heure de début',
      endTime: 'Heure de fin',
      daily: 'Quotidien',
      noDaysSelected: 'Aucun jour sélectionné',
    },
    createScheduleDialog: {
      title: 'Ajouter un nouveau bloc de temps calme',
      description:
        'Tous les horaires sont en UTC. Les synchronisations seront ignorées pendant ces fenêtres de temps.',
      type: 'Type',
      everyDay: 'Tous les jours',
      specificDays: 'Jours spécifiques',
      selectDays: 'Sélectionner les jours',
      startTime: 'Heure de début (UTC)',
      endTime: 'Heure de fin (UTC)',
      hourPlaceholder: 'HH',
      minutePlaceholder: 'MM',
      durationError: 'Le temps calme ne doit pas dépasser 8 heures.',
      cancel: 'Annuler',
      creating: 'Création...',
      create: 'Créer un horaire',
      createSuccess: 'Horaire créé avec succès',
      createError: "Échec de la création de l'horaire",
    },
    burst: {
      menuItem: 'Rafale de synchronisation',
      title: 'Rafale de synchronisation',
      description:
        'Exécute temporairement ce profil à une cadence de synchronisation accélérée. Les périodes de calme sont toujours respectées.',
      windowLabel: 'Fenêtre de rafale (heures)',
      windowHelp:
        "S'exécute selon une cadence accélérée de 5 minutes pendant un maximum de {max} heures, puis revient à la planification normale.",
      activeUntil: "Rafale active jusqu'à {time}.",
      activeBadge: 'Rafale active',
      overlapWarning:
        'Cette fenêtre de rafale chevauche une période de calme ; les synchronisations restent ignorées pendant les périodes de calme.',
      activate: 'Activer la rafale',
      stop: 'Arrêter la rafale',
      cancel: 'Annuler',
      activateSuccess: 'Rafale activée',
      activateError: "Échec de l'activation de la rafale",
      stopSuccess: 'Rafale arrêtée',
      stopError: "Échec de l'arrêt de la rafale",
    },
    daysOfWeek: {
      sunday: 'Dimanche',
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
    },
    runHistory: {
      title: 'Historique des exécutions',
      description: 'Afficher les synchronisations pour ce profil',
      recentRuns: 'Exécutions récentes',
    },
    errors: {
      failedToLoad: 'Échec du chargement du profil',
      copiedToClipboard: 'Copié dans le presse-papiers',
      failedToCopy: 'Échec de la copie',
      profileEnabled: 'Profil activé avec succès',
      profileDisabled: 'Profil désactivé avec succès',
      syncTriggered: 'Synchronisation déclenchée avec succès',
      failedToLoadRuns: 'Échec du chargement des exécutions',
    },
    helpContent: {
      profileHelp: 'Aide du profil',
      profileHelpDescription:
        "En savoir plus sur la gestion des profils, des synchronisations et de l'historique des exécutions",
      setupChecklistTitle: 'Liste de vérification de la configuration du profil',
      setupChecklistDescription: 'Suivre la progression de la configuration de votre profil',
      checklistItems: {
        configureSource: 'Configurer la source',
        configureTarget: 'Configurer la cible',
        selectTables: 'Sélectionner les tables à synchroniser',
        configureQuietTime: 'Configurer votre temps calme',
        configureDeleteMode: 'Configurer le mode de suppression',
        runInitialSync: 'Exécuter la synchronisation initiale',
      },
      allStepsCompleted:
        '✓ Toutes les étapes de configuration sont terminées ! Votre profil est prêt à synchroniser.',
      profileStatus: {
        title: 'État du profil',
        active: 'Actif :',
        activeDescription: 'Le profil est activé et peut exécuter des synchronisations planifiées',
        paused: 'En pause :',
        pausedDescription: "Le profil est désactivé et les synchronisations ne s'exécuteront pas",
      },
      syncActions: {
        title: 'Actions de synchronisation',
        sync: 'Synchroniser :',
        syncDescription:
          'Effectue une synchronisation incrémentale, ne traitant que les données nouvelles ou modifiées',
        resetFullSync: 'Réinitialiser + Synchronisation complète :',
        resetFullSyncDescription:
          "Supprime toutes les données existantes et effectue une synchronisation complète depuis la source. Il s'agit d'une opération destructive.",
        triggerInitialSync: 'Déclencher la synchronisation initiale :',
        triggerInitialSyncDescription:
          'Exécute la première synchronisation après la configuration de votre source et cible',
      },
      sourceAndTarget: {
        title: 'Source et cible',
        source: 'Source :',
        sourceDescription: "La source de données d'où proviennent vos données",
        target: 'Cible :',
        targetDescription: 'La destination où les données synchronisées seront stockées',
        configurationNote:
          'La source et la cible doivent être configurées avant de pouvoir déclencher des synchronisations',
      },
      quietTimePeriods: {
        title: 'Périodes de temps calme',
        description:
          'Configurez des fenêtres de temps pendant lesquelles les synchronisations seront automatiquement ignorées. Cela est utile pour éviter les synchronisations pendant les fenêtres de maintenance ou les périodes de forte utilisation.',
      },
      runHistory: {
        title: 'Historique des exécutions',
        viewAllRuns:
          'Afficher toutes les exécutions de synchronisation pour ce profil, y compris leur état, leur durée et leurs résultats',
        filterRuns: 'Filtrer les exécutions par état (Terminé, Échoué, etc.) ou par table source',
        clickFailedRuns:
          'Cliquer sur les exécutions échouées pour afficher les informations détaillées sur les erreurs',
        usePagination:
          'Utiliser les contrôles de pagination pour naviguer dans les exécutions historiques',
      },
      runStates: {
        title: "États d'exécution",
        completed: 'Terminé :',
        completedDescription: "La synchronisation s'est terminée avec succès",
        failed: 'Échoué :',
        failedDescription: 'La synchronisation a rencontré une erreur',
        extractingLoading: 'Extraction/Chargement :',
        extractingLoadingDescription: 'La synchronisation est en cours',
        scheduled: 'Planifié :',
        scheduledDescription: "La synchronisation est mise en file d'attente pour s'exécuter",
        skipped: 'Ignoré :',
        skippedDescription:
          "La synchronisation a été ignorée (par exemple, en raison d'une période de temps calme)",
        cancelled: 'Annulé :',
        cancelledDescription: 'La synchronisation a été annulée',
      },
    },
  },
  settings: {
    title: 'Paramètres',
    description: 'Gérez les paramètres et préférences de votre compte',
    profileInfo: {
      title: 'Informations de profil',
      description:
        "Mettez à jour vos informations personnelles. Elles seront affichées dans toute l'application.",
    },
    fields: {
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'E-mail',
      emailNote: "L'e-mail ne peut pas être modifié",
    },
    actions: {
      save: 'Enregistrer les modifications',
      saving: 'Enregistrement...',
    },
    language: {
      label: 'Langue',
      description: "Sélectionnez votre langue préférée pour l'interface de l'application.",
      english: 'Anglais',
      french: 'Français',
      german: 'Allemand',
      spanish: 'Espagnol',
    },
    appearance: {
      title: 'Apparence',
      description: "Personnalisez le thème de l'application.",
      themeLabel: 'Thème',
      themeDescription: 'Choisissez le mode clair, sombre ou système.',
      toggleTheme: 'Basculer le thème',
      themeOptions: {
        light: 'Clair',
        dark: 'Sombre',
        system: 'Système',
      },
    },
    notifications: {
      updateSuccess: 'Profil mis à jour avec succès',
      updateError: 'Échec de la mise à jour du profil. Veuillez réessayer.',
    },
    emailNotifications: {
      title: 'Notifications par e-mail',
      description: 'Choisissez les notifications par e-mail que vous souhaitez recevoir.',
      save: 'Enregistrer les préférences',
      saving: 'Enregistrement...',
      updateSuccess: 'Préférences de notification mises à jour avec succès',
      updateError: 'Échec de la mise à jour des préférences de notification. Veuillez réessayer.',
      sections: {
        general: 'Général',
        billing: 'Facturation',
        dataMission: 'Data Mission',
        marketing: 'Marketing',
      },
      events: {
        UserInvited: {
          label: 'Invitations à une organisation',
          description: 'Recevez un e-mail lorsque vous êtes invité à rejoindre une organisation.',
        },
        TrialConsumed: {
          label: 'Essai activé',
          description:
            "Recevez un e-mail lorsqu'un essai de produit est activé, incluant la durée et la date de fin de l'essai.",
        },
        PaymentFailed: {
          label: 'Paiement échoué',
          description: "Recevez un e-mail lorsqu'une tentative de paiement échoue.",
        },
        BillingReminder: {
          label: 'Rappels de facturation',
          description: 'Recevez des rappels concernant la facturation à venir.',
        },
        PaymentMethodChanged: {
          label: 'Méthode de paiement mise à jour',
          description: 'Recevez un e-mail lorsque votre méthode de paiement est mise à jour.',
        },
        SubscriptionCanceled: {
          label: 'Abonnement annulé',
          description: "Recevez un e-mail lorsqu'un abonnement est annulé.",
        },
        SubscriptionSuspended: {
          label: 'Abonnement suspendu',
          description:
            "Recevez un e-mail lorsqu'un abonnement est suspendu en raison de problèmes de paiement.",
        },
        DataMissionSyncFailed: {
          label: 'Échecs de synchronisation',
          description:
            "Recevez un e-mail lorsqu'une table source ne parvient pas à se synchroniser correctement dans Data Mission.",
        },
        ProductUpdates: {
          label: 'Mises à jour produits, fonctionnalités et services',
          description: 'Restez informé des nouvelles fonctionnalités, mises à jour produits et améliorations de service.',
        },
        NewsTrainingArticles: {
          label: 'Actualités, formations et articles',
          description: 'Nous vous enverrons des e-mails contenant des actualités, des mises à jour de formation et des articles utiles sur Data Mission Sync.',
        },
      },
    },
    orgSettings: {
      title: 'Paramètres de l\'organisation',
      description: 'Configurer les préférences et les valeurs par défaut au niveau de l\'organisation',
      organizationName: 'Nom de l\'organisation',
      organizationNameDescription: 'Le nom d\'affichage de cette organisation',
      organizationNameRequired: 'Le nom de l\'organisation est requis',
      billingCountry: 'Pays de facturation',
      billingCountryDescriptionSet: 'Le pays de facturation de cette organisation (ne peut pas être modifié)',
      billingCountryDescriptionNotSet: 'Sélectionnez le pays de facturation de cette organisation (ne peut pas être modifié une fois défini)',
      defaultRegion: 'Région par défaut',
      defaultRegionDescription: 'La région Azure par défaut pour les nouveaux profils de cette organisation',
      noDefaultRegion: 'Aucune région par défaut',
      save: 'Enregistrer les paramètres de l\'organisation',
      saving: 'Enregistrement...',
      updateSuccess: 'Paramètres de l\'organisation mis à jour avec succès',
      updateError: 'Échec de la mise à jour des paramètres de l\'organisation',
      noOrganizationSelected: 'Aucune organisation sélectionnée',
    },
    featureFlags: {
      title: 'Indicateurs de fonctionnalités',
      description: 'Activer ou désactiver des fonctionnalités pour cette organisation.',
    },
    legalDocuments: {
      title: 'Documents juridiques',
      description: 'Consultez l\'état d\'acceptation de nos documents juridiques.',
      privacyPolicy: 'Politique de confidentialité',
      termsOfUse: 'Conditions d\'utilisation',
      currentVersion: 'Version actuelle',
      acceptedOn: 'Accepté le',
      neverAccepted: 'Pas encore accepté',
      view: 'Voir',
      close: 'Fermer',
      version: 'Version',
    },
  },
  targets: {
    createDialog: {
      title: 'Créer une cible Azure SQL',
      description: 'Ajouter une nouvelle base de données cible Azure SQL à ce profil',
      addTarget: 'Ajouter une cible',
      onlyOneTargetTooltip:
        'Une seule cible par profil. Supprimez la cible existante pour en créer une nouvelle.',
      targetType: 'Type de cible',
      targetTypeDescription:
        'Seules les cibles de base de données Azure SQL sont actuellement prises en charge',
      authType: "Type d'authentification",
      authTypeServicePrincipal: 'Principal de service (AAD)',
      authTypeServicePrincipalDescription:
        "S'authentifier avec les identifiants d'un principal de service Azure AD",
      authTypeSqlCredential: 'Identifiants SQL',
      authTypeSqlCredentialDescription:
        "S'authentifier avec un nom d'utilisateur et un mot de passe SQL",
      useSourceClientId: "Utiliser l'ID client de la source",
      useSourceClientIdDescription:
        "Copiez l'ID client de la source. Vous devrez toujours fournir l'ID locataire et le secret client.",
      usingClientIdFromSource: "Utilisation de l'ID client de la source",
      tenantId: 'ID locataire',
      tenantIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      tenantIdDescription: "L'ID locataire Azure AD",
      clientId: 'ID client',
      clientIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      clientIdDescription: "L'ID d'application Azure AD (client)",
      clientSecret: 'Secret client',
      clientSecretPlaceholder: 'Entrer le secret client',
      clientSecretDescription: "Le secret client de l'application Azure AD",
      username: "Nom d'utilisateur",
      usernamePlaceholder: "Entrer le nom d'utilisateur SQL",
      usernameDescription: "Le nom d'utilisateur de connexion SQL Server",
      password: 'Mot de passe',
      passwordPlaceholder: 'Entrer le mot de passe SQL',
      passwordDescription: 'Le mot de passe de connexion SQL Server',
      encryptConnection: 'Chiffrer la connexion',
      encryptConnectionDescription: 'Désactiver si vous vous connectez à un SQL Server local sans TLS configuré',
      server: 'Serveur',
      serverPlaceholder: 'myserver.database.windows.net',
      serverDescription: 'Nom du serveur Azure SQL (par ex., myserver.database.windows.net)',
      database: 'Base de données',
      databasePlaceholder: 'MaBaseDeDonnées',
      databaseDescription: 'Nom de la base de données cible',
      schema: 'Schéma',
      schemaPlaceholder: 'dbo',
      schemaDescription: "Nom du schéma SQL (par défaut : 'dbo')",
      agent: 'Agent',
      agentPlaceholder: 'Sélectionner un agent',
      agentDescription: "Attribuer optionnellement un agent auto-hébergé pour exécuter les opérations de synchronisation de cette cible",
      agentNone: 'Aucun (hébergé dans le cloud)',
      connectionTest: 'Test de connexion',
      testConnection: 'Tester la connexion',
      testing: 'Test en cours...',
      testDescription: 'Testez votre connexion avant de créer la cible',
      connectionSuccessful: 'Connexion réussie',
      cancel: 'Annuler',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      saveAndCreateSource: 'Enregistrer et créer la source',
      allFieldsRequired: 'Tous les champs sont requis pour tester la connexion',
      validationFailed: 'La validation a échoué. Veuillez vérifier le formulaire.',
    },
    editDialog: {
      buttonText: 'Modifier la cible',
      title: 'Modifier la cible',
      description: 'Mettre à jour la configuration de la cible',
      tenantId: 'ID locataire',
      tenantIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      tenantIdDescription: "L'ID locataire Azure AD",
      clientId: 'ID client',
      clientIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      clientIdDescription: "L'ID d'application Azure AD (client)",
      clientSecret: 'Secret client',
      clientSecretPlaceholder: 'Entrer le secret client',
      clientSecretDescription: "Le secret client de l'application Azure AD",
      tenantIdRequired: "L'ID locataire est requis",
      clientIdRequired: "L'ID client est requis",
      clientSecretRequired: 'Le secret client est requis',
      usernameRequired: "Le nom d'utilisateur est requis",
      passwordRequired: 'Le mot de passe est requis',
      username: "Nom d'utilisateur",
      usernamePlaceholder: "Entrer le nom d'utilisateur SQL",
      usernameDescription: "Le nom d'utilisateur de connexion SQL Server",
      password: 'Mot de passe',
      passwordPlaceholder: 'Entrer le mot de passe SQL',
      passwordDescription: 'Le mot de passe de connexion SQL Server',
      encryptConnection: 'Chiffrer la connexion',
      encryptConnectionDescription: 'Désactiver si vous vous connectez à un SQL Server local sans TLS configuré',
      cancel: 'Annuler',
      update: 'Mettre à jour',
      updateSuccess: 'Cible mise à jour avec succès',
      agent: 'Agent',
      agentPlaceholder: 'Sélectionner un agent',
      agentDescription: "Attribuer un agent auto-hébergé pour exécuter les opérations de synchronisation de cette cible",
      agentNone: 'Aucun (hébergé dans le cloud)',
      testConnection: 'Tester la connexion',
      connectionSuccessful: 'Connexion réussie',
    },
    prefixDialog: {
      buttonText: 'Modifier le préfixe de table',
      title: 'Modifier le préfixe de table',
      description: 'Le préfixe de table est appliqué à chaque table créée par ce profil.',
      label: 'Préfixe de table',
      placeholder: 'ex. dms_',
      hint: 'Lettres, chiffres et traits de soulignement uniquement. Laissez vide pour aucun préfixe.',
      invalidPrefix: 'Le préfixe de table ne peut contenir que des lettres, des chiffres et des traits de soulignement.',
      tablesTooLong: 'Certaines tables ne peuvent pas utiliser ce préfixe car leur nom dépasserait la limite SQL de 128 caractères :',
      warningTitle: 'Cette opération supprimera et reconstruira toutes les tables synchronisées',
      warningOperation1: 'Toutes les tables cibles (finales et intermédiaires) de ce profil sont supprimées.',
      warningOperation2: 'Elles sont recréées avec le nouveau préfixe et resynchronisées à partir de zéro.',
      warningOperation3: "Les données synchronisées sont indisponibles jusqu'à la fin de la resynchronisation.",
      acknowledge: 'Je comprends que toutes les tables synchronisées seront supprimées et reconstruites.',
      cancel: 'Annuler',
      apply: 'Modifier le préfixe',
      updateSuccess: 'Préfixe de table mis à jour',
    },
    notifications: {
      createSuccess: 'Cible créée avec succès',
      createError: 'Échec de la création de la cible. Veuillez réessayer.',
    },
  },
  sources: {
    pageSizeField: {
      label: 'Taille de page',
      description: "Lignes récupérées par requête d'extraction ({min}–{max}). Des valeurs plus élevées réduisent le nombre d'appels.",
    },
    createDialog: {
      title: 'Créer une source Dataverse',
      description: 'Ajouter une nouvelle source de données Dataverse à ce profil',
      addSource: 'Ajouter une source',
      onlyOneSourceTooltip:
        'Une seule source par profil. Supprimez la source existante pour en créer une nouvelle.',
      sourceType: 'Type de source',
      sourceTypeDescription:
        'Seules les sources Microsoft Dataverse sont actuellement prises en charge',
      baseUrl: 'URL de base',
      baseUrlPlaceholder: 'https://org.crm.dynamics.com',
      baseUrlDescription: "L'URL HTTPS de votre point de terminaison API Dataverse",
      clientId: 'ID client',
      clientIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      clientIdDescription: "L'ID d'application Azure AD (client)",
      clientSecret: 'Secret client',
      clientSecretPlaceholder: 'Entrer le secret client',
      clientSecretDescription: "Le secret client de l'application Azure AD",
      connectionTest: 'Test de connexion',
      testConnection: 'Tester la connexion',
      testing: 'Test de connexion en cours...',
      testDescription: 'Testez votre connexion avant de créer la source',
      connectionSuccessful: 'Connexion réussie',
      cancel: 'Annuler',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      saveAndCreateTarget: 'Enregistrer et créer la cible',
      allFieldsRequired: 'Tous les champs sont requis pour tester la connexion',
      validationFailed: 'La validation a échoué. Veuillez vérifier le formulaire.',
    },
    editDialog: {
      buttonText: 'Modifier la source',
      title: 'Modifier la source',
      description: 'Mettre à jour la configuration de la source',
      baseUrl: 'URL de base',
      baseUrlDescription: "L'URL HTTPS de votre point de terminaison API Dataverse",
      pageSize: 'Taille de page',
      pageSizeDescription: "Enregistrements récupérés par appel à l'API Dataverse (1000–5000). Réduisez cette valeur si des tables très larges expirent ; augmentez-la pour réduire les appels à l'API. Par défaut 3000.",
      pageSizeRange: 'La taille de page doit être comprise entre 1000 et 5000',
      clientId: 'ID client',
      clientIdDescription: "L'ID d'application Azure AD (client)",
      clientSecret: 'Secret client',
      clientSecretDescription: "Le secret client de l'application Azure AD",
      consumerKey: 'Clé consommateur',
      consumerKeyDescription: 'La clé consommateur de votre application connectée Salesforce',
      secret: 'Secret',
      secretDescription: 'Le secret consommateur de votre application connectée Salesforce',
      baseUrlRequired: "L'URL de base est requise",
      clientIdRequired: "L'ID client est requis",
      clientSecretRequired: 'Le secret client est requis',
      consumerKeyRequired: 'La clé consommateur est requise',
      secretRequired: 'Le secret est requis',
      instanceUrlRequired: "L'URL de l'instance est requise",
      tenantIdRequired: "L'ID de locataire est requis",
      environmentRequired: "L'environnement est requis",
      companyRequired: 'Veuillez sélectionner une entreprise après avoir testé la connexion',
      testConnection: 'Tester la connexion',
      connectionSuccessful: 'Connexion réussie',
      cancel: 'Annuler',
      updating: 'Mise à jour...',
      update: 'Mettre à jour la source',
      updateSuccess: 'Source mise à jour avec succès',
    },
    sourceTablesDialog: {
      buttonText: 'Ajouter une table source',
      title: 'Ajouter des tables sources',
      description: 'Sélectionnez une ou plusieurs tables de cette source à synchroniser',
      tables: 'Tables',
      selected: 'sélectionné(s)',
      selectAll: 'Tout sélectionner',
      deselectAll: 'Tout désélectionner',
      searchPlaceholder: 'Rechercher des tables...',
      loading: 'Chargement des tables...',
      noTables: 'Aucune table trouvée',
      selectAtLeastOne: 'Veuillez sélectionner au moins une table',
      cancel: 'Annuler',
      adding: 'Ajout...',
      addTables: 'Ajouter',
      addSuccess: 'Tables sources ajoutées avec succès!',
      timestampField: 'Choisir un champ horodatage pour les synchronisations incrémentales',
      timestampFieldDescription: 'Champ utilisé pour la synchronisation incrémentale',
      timestampFieldNone: 'Aucun (réplication complète)',
      incrementalSyncVia: 'Synchronisation incrémentielle via {field}',
      fullReplication: 'Réplication complète (aucun champ horodatage disponible)',
      noTimestampFieldNotice: "Aucune colonne d'horodatage n'est disponible pour cette table. Chaque synchronisation effectuera une réplication complète de tous les enregistrements.",
      nameTooLongForPrefix: 'Nom trop long pour le préfixe de table de ce profil.',
    },
    tableBatch: {
      progress: 'Ajout de {done} sur {total}...',
      partialFailure: "{added} tables sur {total} ont été ajoutées. {failed} n'ont pas pu être ajoutées :",
      moreTables: '(+{count} de plus)',
      syncStartFailed: "{count} tables ont été ajoutées, mais leur synchronisation initiale n'a pas pu démarrer. Lancez une synchronisation depuis la page du profil.",
    },
    tablePaste: {
      open: 'Coller une liste de tables',
      description: 'Collez les noms logiques des tables, un par ligne ou séparés par des virgules. La correspondance ignore les majuscules et minuscules.',
      placeholder: 'account\ncontact\nmsdyn_matchingcriteria',
      resolve: 'Sélectionner les tables correspondantes',
      cancel: 'Annuler',
      emptyInput: 'Collez au moins un nom de table.',
      summary: '{selected} sélectionnées, {alreadySelected} déjà sélectionnées, {alreadyAdded} déjà ajoutées, {notSyncable} non synchronisables, {notFound} introuvables.',
      columnTable: 'Table',
      columnResult: 'Résultat',
      columnDetails: 'Détails',
      resultAlreadyAdded: 'Déjà ajoutée',
      alreadyAddedDetail: 'Cette table est déjà ajoutée à ce profil.',
      resultNotSyncable: 'Non synchronisable',
      resultNotFound: 'Introuvable',
      didYouMean: 'Vouliez-vous dire {name} ?',
      noMatch: "Aucune table portant ce nom logique n'existe dans la source.",
      copyUnresolved: 'Copier les noms non résolus',
      copySelected: 'Copier la sélection',
      copied: 'Copié',
      dismiss: 'Fermer',
    },
    sourceCapacity: {
      queuedTitle: 'Tables en attente de capacité Dataverse',
      queuedDescription:
        '{count} tables sont en attente de capacité Dataverse (limite : {limit} requêtes simultanées par environnement). Les synchronisations se termineront, simplement plus lentement.',
      manyTablesHint:
        "Les synchronisations de cet environnement Dataverse exécutent jusqu'à {limit} requêtes à la fois. Avec {count} tables, les synchronisations volumineuses seront mises en file d'attente et prendront plus de temps.",
      selectionHint:
        "Les synchronisations de cet environnement Dataverse exécutent jusqu'à {limit} requêtes à la fois. Avec {count} tables sélectionnées, la synchronisation initiale sera mise en file d'attente et prendra plus de temps.",
      dedicatedAppNote:
        "Utilisez une inscription d'application dédiée à Data Mission Sync. Dataverse limite les requêtes simultanées par utilisateur d'application ; la partager avec d'autres intégrations peut entraîner une limitation.",
    },
    notifications: {
      createSuccess: 'Source créée avec succès',
      createError: 'Échec de la création de la source. Veuillez réessayer.',
    },
  },
  wizard: {
    advancedSettings: {
      title: 'Paramètres avancés',
      description: "Facultatif. La plupart des clients peuvent les laisser tels quels.",
    },
    steps: {
      profile: 'Profil',
      source: 'Source',
      target: 'Cible',
      tables: 'Tables',
      quietTime: 'Heure calme',
      deleteMode: 'Mode de suppression',
      initialSync: 'Synchronisation initiale',
    },
    availableTableDisabledReasons: {
      ChangeTrackingDisabled: "Activez le suivi des modifications pour utiliser cette entité.",
      NotSupported: "Cette entité n'est pas prise en charge actuellement. Veuillez contacter le support pour obtenir de l'aide.",
      RelatedChangeTrackingDisabled: 'Activez le suivi des modifications sur les deux tables liées pour utiliser cette table de relation.',
      VirtualTable: "Il s'agit d'une table virtuelle : ses données ne sont pas stockées dans Dataverse, elle ne peut donc pas être synchronisée.",
    },
    common: {
      back: 'Retour',
      next: 'Suivant',
      cancel: 'Annuler',
      create: 'Créer',
      save: 'Enregistrer',
      delete: 'Supprimer',
      edit: 'Modifier',
      add: 'Ajouter',
      remove: 'Retirer',
      update: 'Mettre à jour',
      submit: 'Soumettre',
      close: 'Fermer',
      copy: 'Copier',
      copied: 'Copié',
      copyToClipboard: 'Copié dans le presse-papiers',
      failedToCopy: 'Échec de la copie',
    },
    profile: {
      title: 'Créer un profil',
      titleEdit: 'Détails du profil',
      description: 'Configurer un nouveau profil de synchronisation de données',
      descriptionEdit: 'Afficher la configuration de votre profil',
      cardTitle: 'Détails du profil',
      cardDescription: 'Configurer les paramètres de base de votre profil',
      profileName: 'Nom du profil',
      profileNamePlaceholder: 'Mon profil de synchronisation de données',
      region: 'Région',
      regionPlaceholder: 'Sélectionner une région',
      creating: 'Création...',
      nextConfigureSource: 'Suivant : Configurer la source',
      profileCreatedSuccessfully: 'Profil créé avec succès',
      pleaseEnterProfileName: 'Veuillez entrer un nom de profil',
      advancedLengthsInvalid: 'Les longueurs de colonnes Dataverse doivent être comprises entre 50 et 4000.',
    },
    source: {
      title: 'Configurer la source',
      description: 'Connectez-vous à votre source de données',
      cardTitle: 'Détails de connexion',
      cardDescription: 'Entrez vos identifiants et détails de connexion',
      sourceType: 'Type de source',
      selectSourceType: 'Sélectionnez un type de source',
      dataverse: 'Dataverse',
      businessCentral: 'Business Central',
      salesforce: 'Salesforce',
      baseUrl: 'URL de base',
      baseUrlPlaceholder: 'https://yourorg.crm.dynamics.com',
      pageSize: 'Taille de page',
      pageSizePlaceholder: '3000',
      pageSizeDescription: "Enregistrements récupérés par appel à l'API Dataverse (1000–5000). Réduisez cette valeur si des tables très larges expirent ; augmentez-la pour réduire les appels à l'API. Par défaut 3000.",
      pageSizeRange: 'La taille de page doit être comprise entre 1000 et 5000',
      tenantId: 'ID de locataire',
      tenantIdPlaceholder: "Entrer l'ID de locataire Azure AD",
      bcEnvironment: 'Environnement',
      bcEnvironmentPlaceholder: 'ex. production',
      instanceUrl: "URL de l'instance",
      instanceUrlPlaceholder: 'https://mycompany.my.salesforce.com',
      isSandbox: 'Organisation sandbox',
      isSandboxDescription: "Activer si c'est un environnement sandbox Salesforce",
      clientId: 'ID client',
      clientIdPlaceholder: "Entrer l'ID client",
      clientSecret: 'Secret client',
      clientSecretPlaceholder: 'Entrer le secret client',
      consumerKey: 'Clé consommateur',
      consumerKeyPlaceholder: 'Entrer la clé consommateur',
      secret: 'Secret',
      secretPlaceholder: 'Entrer le secret',
      testConnection: 'Tester la connexion',
      testConnectionAndLoadCompanies: 'Tester la connexion & charger les entreprises',
      testing: 'Test de connexion en cours...',
      connectionSuccessful: 'Connexion réussie',
      company: 'Entreprise',
      companyPlaceholder: 'Sélectionner une entreprise',
      noCompaniesFound: 'Aucune entreprise trouvée',
      allFieldsRequired: 'Tous les champs sont requis pour tester la connexion',
      testBeforeProceeding: 'Veuillez tester la connexion avec succès avant de continuer',
      selectCompanyBeforeProceeding: 'Veuillez sélectionner une entreprise avant de continuer',
      back: 'Retour',
      next: 'Suivant : Configurer la cible',
      creating: 'Création...',
    },
    target: {
      title: 'Configurer la cible',
      description: 'Connectez-vous à votre base de données Azure SQL',
      cardTitle: 'Connexion Azure SQL',
      cardDescription: 'Entrez vos identifiants et détails de base de données Azure SQL',
      warning:
        'Avertissement : Après la première synchronisation, la cible ne peut pas être modifiée.',
      firewallTitle: 'Configuration du pare-feu requise',
      firewallDescription:
        'Pour permettre à Data Mission de se connecter à votre serveur Azure SQL, choisissez une de ces options :',
      firewallOptionAzure:
        'Activez "Autoriser les services et ressources Azure à accéder à ce serveur" dans les paramètres réseau de votre serveur Azure SQL.',
      firewallOptionAzureLabel: 'Option 2 :',
      firewallOptionIpRecommended: 'Option 1 (Recommandée) :',
      firewallOptionIpDescription:
        'Ajoutez l\'adresse IP statique suivante aux règles de pare-feu de votre serveur Azure SQL :',
      firewallIpUnavailable:
        'IP statique non disponible pour cette région. Utilisez l\'option 1 à la place.',
      firewallSummary:
        'Une configuration réseau supplémentaire peut être nécessaire pour permettre à nos services d\'accéder à votre serveur Azure SQL.',
      firewallLearnMore: 'En savoir plus',
      firewallClose: 'Fermer',
      authType: "Type d'authentification",
      authTypeServicePrincipal: 'Principal de service (AAD)',
      authTypeServicePrincipalDescription:
        "S'authentifier avec les identifiants d'un principal de service Azure AD",
      authTypeSqlCredential: 'Identifiants SQL',
      authTypeSqlCredentialDescription:
        "S'authentifier avec un nom d'utilisateur et un mot de passe SQL",
      useSourceClientId: "Utiliser l'ID client de la source",
      useSourceClientIdDescription:
        "Copiez l'ID client de la source. Vous devrez toujours fournir l'ID locataire et le secret client.",
      usingClientIdFromSource: "Utilisation de l'ID client de la source",
      tenantId: 'ID locataire',
      tenantIdPlaceholder: "Entrer l'ID locataire",
      clientId: 'ID client',
      clientIdPlaceholder: "Entrer l'ID client",
      clientSecret: 'Secret client',
      clientSecretPlaceholder: 'Entrer le secret client',
      username: "Nom d'utilisateur",
      usernamePlaceholder: "Entrer le nom d'utilisateur SQL",
      usernameDescription: "Le nom d'utilisateur de connexion SQL Server",
      password: 'Mot de passe',
      passwordPlaceholder: 'Entrer le mot de passe SQL',
      passwordDescription: 'Le mot de passe de connexion SQL Server',
      encryptConnection: 'Chiffrer la connexion',
      encryptConnectionDescription: 'Désactiver si vous vous connectez à un SQL Server local sans TLS configuré',
      server: 'Serveur',
      serverPlaceholder: 'yourserver.database.windows.net',
      database: 'Base de données',
      databasePlaceholder: 'Entrer le nom de la base de données',
      schema: 'Nom du schéma',
      schemaPlaceholder: 'dbo',
      tablePrefix: 'Préfixe de table (facultatif)',
      tablePrefixPlaceholder: 'ex. dms_',
      tablePrefixDescription: 'Appliqué à chaque table créée par ce profil (ex. dms_account). Incluez votre propre séparateur. Lettres, chiffres et traits de soulignement uniquement.',
      tablePrefixInvalid: 'Le préfixe de table ne peut contenir que des lettres, des chiffres et des traits de soulignement.',
      agent: 'Agent',
      agentPlaceholder: 'Sélectionner un agent',
      agentDescription: "Attribuer optionnellement un agent auto-hébergé pour exécuter les opérations de synchronisation de cette cible",
      agentNone: 'Aucun (hébergé dans le cloud)',
      testConnection: 'Tester la connexion',
      testing: 'Test de connexion en cours...',
      connectionSuccessful: 'Connexion réussie',
      allFieldsRequired: 'Tous les champs sont requis pour tester la connexion',
      testBeforeProceeding: 'Veuillez tester la connexion avec succès avant de continuer',
      validationFailed: 'La validation a échoué. Veuillez vérifier le formulaire.',
      back: 'Retour',
      next: 'Suivant : Sélectionner les tables',
      creating: 'Création...',
    },
    tables: {
      title: 'Sélectionner les tables',
      description: 'Choisissez les tables à synchroniser',
      cardTitle: 'Tables disponibles',
      cardDescription:
        'Sélectionnez une ou plusieurs tables de votre source Dataverse à synchroniser',
      tablesLabel: 'Tables',
      selected: 'sélectionné',
      selectAll: 'Tout sélectionner',
      deselectAll: 'Tout désélectionner',
      searchPlaceholder: 'Rechercher des tables par nom...',
      loadingTables: 'Chargement des tables...',
      noTablesFound: 'Aucune table trouvée correspondant à votre recherche',
      noTablesAvailable: 'Aucune table disponible',
      pleaseSelectAtLeastOne: 'Veuillez sélectionner au moins une table',
      sourceNotFound: 'Source introuvable',
      addingTables: 'Ajout des tables...',
      finishAddTables: 'Terminer et ajouter {count} table',
      finishAddTablesPlural: 'Terminer et ajouter {count} tables',
      sourceTablesAddedSuccessfully: 'Tables source ajoutées avec succès',
      nextConfigureQuietTime: "Suivant : Configurer l'heure calme",
      back: 'Retour',
      timestampField: 'Choisir un champ horodatage pour les synchronisations incrémentales',
      timestampFieldDescription: 'Champ utilisé pour la synchronisation incrémentielle',
      timestampFieldNone: 'Aucun (réplication complète)',
      incrementalSyncVia: 'Synchronisation incrémentielle via {field}',
      fullReplication: 'Réplication complète (aucun champ horodatage disponible)',
      noTimestampFieldNotice: "Aucune colonne d'horodatage n'est disponible pour cette table. Chaque synchronisation effectuera une réplication complète de tous les enregistrements.",
      nameTooLongForPrefix: 'Nom trop long pour le préfixe de table de ce profil.',
    },
    quietTime: {
      title: "Configurer l'heure calme",
      description:
        'Définir les fenêtres de temps pendant lesquelles les synchronisations seront automatiquement ignorées',
      cardTitle: "Période d'heure calme",
      cardDescription:
        'Configurer les fenêtres de temps pendant lesquelles les synchronisations seront ignorées. Ceci est optionnel mais recommandé.',
      infoAlert:
        "Toutes les heures sont en UTC. Les périodes d'heure calme aident à éviter les synchronisations pendant les fenêtres de maintenance ou les heures de pointe.",
      existingSchedules:
        "Vous avez {count} horaire d'heure calme configuré. Vous pouvez en ajouter d'autres ci-dessous ou passer à l'étape suivante.",
      existingSchedulesPlural:
        "Vous avez {count} horaires d'heure calme configurés. Vous pouvez en ajouter d'autres ci-dessous ou passer à l'étape suivante.",
      type: 'Type',
      typeDaily: 'Tous les jours',
      typeWeekly: 'Jours spécifiques',
      selectDays: 'Sélectionner les jours',
      startTime: 'Heure de début (UTC)',
      endTime: 'Heure de fin (UTC)',
      hourPlaceholder: 'HH',
      minutePlaceholder: 'MM',
      durationExceeded:
        "L'heure calme ne doit pas dépasser 8 heures. Durée actuelle : {hours} heures",
      addQuietTimeBlock: "Ajouter un bloc d'heure calme",
      creating: 'Création...',
      quietTimeScheduleCreatedSuccessfully: "Horaire d'heure calme créé avec succès",
      back: 'Retour',
      nextConfigureDeleteMode: 'Suivant : Configurer le mode de suppression',
      sunday: 'Dimanche',
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      configuredSchedules: 'Horaires configurés',
      recurrence: 'Récurrence',
      noDaysSelected: 'Aucun jour sélectionné',
    },
    deleteMode: {
      title: 'Configurer le mode de suppression',
      description:
        'Choisissez comment les enregistrements supprimés sont gérés lors de la synchronisation',
      cardTitle: 'Mode de suppression',
      cardDescription:
        'Sélectionnez comment vous voulez gérer les enregistrements supprimés de la source',
      softDelete: 'Suppression logique',
      softDeleteDescription:
        "Marquer les enregistrements comme supprimés (IsDeleted = true) mais les conserver dans la base de données. Idéal pour les pistes d'audit et les données historiques.",
      hardDelete: 'Suppression physique',
      hardDeleteDescription:
        "Supprimer physiquement les enregistrements de la base de données lorsqu'ils sont supprimés dans la source.",
      infoMessage:
        "Ce paramètre détermine comment les enregistrements supprimés dans le système source sont gérés dans la base de données cible. Choisissez avec soin car cela affecte l'intégrité des données.",
      recommended: 'Recommandé',
      warningAfterInitialSync:
        'Avertissement : Modifier le mode de suppression après la synchronisation initiale peut causer des incohérences de données. Procédez avec prudence.',
      saving: 'Enregistrement...',
      nextRunInitialSync: 'Suivant : Exécuter la synchronisation initiale',
      successMessage: 'Mode de suppression configuré avec succès',
      back: 'Retour',
    },
    initialSync: {
      title: 'Exécuter la synchronisation initiale',
      description:
        'Déclencher la première synchronisation pour commencer à synchroniser vos données',
      cardTitle: 'Synchronisation initiale',
      cardDescription:
        'Exécutez votre première synchronisation pour commencer à synchroniser les données de votre source vers votre cible',
      infoAlert:
        "La synchronisation initiale traitera toutes les tables sélectionnées et créera l'ensemble de données initial dans votre base de données cible. Cela peut prendre un certain temps selon la quantité de données.",
      triggeredSuccessfully:
        'Synchronisation initiale déclenchée avec succès ! Redirection vers la page du profil...',
      triggering: 'Déclenchement de la synchronisation initiale...',
      triggeringButton: 'Déclenchement...',
      triggeredButton: 'Déclenché',
      triggerInitialSync: 'Déclencher la synchronisation initiale',
      initialSyncTriggeredSuccessfully: 'Synchronisation initiale déclenchée avec succès',
      back: 'Retour',
    },
  },
  organizationSetupWizard: {
    title: 'Mission Data',
    createError: "Échec de la création de l'organisation",
    unexpectedError: "Une erreur inattendue s'est produite",
    regionSetupError: "Échec de la mise à jour des paramètres de l'organisation",
    setupComplete: "Configuration de l'organisation terminée",
  },
  organizationWizard: {
    welcome: {
      title: 'Bienvenue dans Mission Impact Data Mission',
      description: 'Configurons votre organisation',
      intro: 'Pour commencer, vous devrez créer une organisation. Une organisation vous aide à :',
      benefit1: 'Gérer les membres de votre équipe et leur accès',
      benefit2: 'Organiser vos sources de données et profils',
      benefit3: "Collaborer avec d'autres sur les tâches d'intégration de données",
      benefit4: 'Séparer votre travail des autres organisations',
      creatorNote:
        "En tant que créateur, vous deviendrez automatiquement l'Administrateur avec un contrôle total sur votre organisation.",
      getStarted: 'Commencer',
    },
    name: {
      title: 'Créer votre organisation',
      description: 'Choisissez un nom pour votre organisation',
      organizationName: "Nom de l'organisation",
      organizationNamePlaceholder: "Entrer le nom de l'organisation",
      organizationNameCannotBeEmpty: "Le nom de l'organisation ne peut pas être vide",
      creating: 'Création...',
      createOrganization: "Créer l'organisation",
    },
    language: {
      title: 'Choisissez votre langue',
      description: "Sélectionnez votre langue préférée pour l'application",
      languageLabel: 'Langue',
      languageDescription: 'Vous pourrez modifier ceci plus tard dans les paramètres',
      english: 'English',
      french: 'Français',
      german: 'Deutsch',
      spanish: 'Español',
      continue: 'Continuer',
    },
    region: {
      title: 'Définir la région par défaut',
      description: 'Choisissez une région Azure par défaut pour votre organisation',
      defaultRegion: 'Région par défaut',
      defaultRegionDescription:
        'La région Azure par défaut pour les nouveaux profils dans cette organisation',
      noDefaultRegion: 'Aucune région par défaut',
      saving: 'Enregistrement...',
      complete: 'Terminer la configuration',
    },
    success: {
      title: 'Organisation créée avec succès',
      description: 'Votre organisation est prête à être utilisée',
      message: "Votre organisation a été créée et vous avez été assigné en tant qu'Administrateur.",
      redirecting: 'Redirection vers le tableau de bord...',
    },
  },
  userOnboardingWizard: {
    title: 'Bienvenue dans Data Mission',
    steps: {
      welcome: 'Bienvenue',
      language: 'Langue',
      theme: 'Thème',
      organization: 'Organisation',
      eula: 'Accord',
      complete: 'Terminé',
    },
    welcomeStep: {
      title: 'Bienvenue dans Data Mission',
      description: 'Configurons votre compte',
      intro:
        'Data Mission vous aide à synchroniser vos données Microsoft Dataverse vers votre propre base de données SQL Server, vous donnant un contrôle total sur vos données pour les rapports et analyses.',
      feature1: 'Synchronisation automatique et incrémentale des données',
      feature2: 'Contrôle total sur vos données synchronisées',
      feature3: 'Configuration facile avec un assistant guidé',
      getStarted: 'Commencer',
    },
    languageStep: {
      title: 'Choisissez votre langue',
      description: "Sélectionnez votre langue préférée pour l'application",
      languageLabel: 'Langue',
      continue: 'Continuer',
    },
    themeStep: {
      title: 'Choisissez votre thème',
      description: 'Sélectionnez votre thème de couleur préféré',
      light: 'Clair',
      lightDescription: 'Un thème lumineux pour une utilisation de jour',
      dark: 'Sombre',
      darkDescription: 'Un thème plus sombre, plus agréable pour les yeux',
      system: 'Système',
      systemDescription: "S'adapter automatiquement aux paramètres de votre système",
      back: 'Retour',
      continue: 'Continuer',
    },
    organizationStep: {
      title: 'Vos organisations',
      description:
        'Les organisations vous aident à gérer votre équipe et vos données. Une organisation est requise pour utiliser Data Mission.',
      activeMemberships: 'Adhésions actives',
      pendingInvites: 'Invitations en attente',
      pendingInvitesDescription: 'Vous avez été invité à rejoindre les organisations suivantes',
      role: 'Rôle',
      expires: 'Expire',
      accept: 'Accepter',
      accepting: 'Acceptation...',
      decline: 'Refuser',
      declining: 'Refus...',
      createNew: 'Créer une organisation',
      createNewDescription: 'Commencez avec votre propre organisation',
      organizationName: "Nom de l'organisation",
      organizationNamePlaceholder: "Entrez le nom de l'organisation",
      organizationNameRequired: "Le nom de l'organisation est requis",
      creating: 'Création...',
      create: "Créer l'organisation",
      back: 'Retour',
      acceptError: "Échec de l'acceptation de l'invitation. Veuillez réessayer.",
      declineError: "Échec du refus de l'invitation. Veuillez réessayer.",
      createError: "Échec de la création de l'organisation. Veuillez réessayer.",
    },
    agreementStep: {
      title: "Conditions d'utilisation",
      description: 'Veuillez lire et accepter les conditions pour continuer',
      loading: 'Chargement...',
      loadError: "Échec du chargement de l'accord. Veuillez réessayer plus tard.",
      accept: 'Accepter',
      accepting: 'Acceptation...',
      back: 'Retour',
      acceptError: "Échec de l'acceptation de l'accord. Veuillez réessayer.",
      noAgreementsRequired: "Aucun accord ne nécessite d'acceptation pour le moment.",
      privacyPolicyTitle: 'Politique de confidentialité',
      termsOfUseTitle: "Conditions d'utilisation",
      scrollToAccept: 'Faites défiler vers le bas pour accepter',
    },
    communicationPreferencesStep: {
      title: 'Choisissez vos préférences de communication',
      description: 'Sélectionnez les types de communications que vous souhaitez recevoir',
      productUpdates: {
        label: 'Mises à jour produits, fonctionnalités et services',
        description: 'Restez informé des nouvelles fonctionnalités, mises à jour produits et améliorations de service.',
      },
      newsTrainingArticles: {
        label: 'Actualités, formations et articles',
        description: 'Nous vous enverrons des e-mails contenant des actualités, des mises à jour de formation et des articles utiles sur Data Mission Sync.',
      },
      back: 'Retour',
      continue: 'Continuer',
      saving: 'Enregistrement...',
      saveError: 'Échec de l\'enregistrement des préférences de communication. Veuillez réessayer.',
    },
    completeStep: {
      title: 'Configuration terminée',
      description: 'Vous êtes prêt à utiliser Data Mission',
      summary: 'Vos préférences',
      language: 'Langue',
      theme: 'Thème',
      completing: 'Finalisation...',
      complete: 'Commencer',
      error: 'Échec de la configuration. Veuillez réessayer.',
    },
  },
  dialogs: {
    deleteProfile: {
      title: 'Supprimer le profil',
      description: 'Êtes-vous sûr de vouloir supprimer le profil',
      confirmationLabel: 'nom du profil',
      buttonText: 'Supprimer le profil',
      successMessage: 'Profil supprimé avec succès',
      warningIntro: 'La suppression de ce profil supprimera également définitivement :',
      warningSources: 'Toutes les sources associées à ce profil',
      warningTargets: 'Toutes les cibles associées à ce profil',
      warningSourceTables: 'Toutes les tables source associées aux sources',
      warningWebhooks: 'Tous les abonnements webhook associés aux sources',
    },
    deleteSource: {
      title: 'Supprimer la source',
      description: 'Êtes-vous sûr de vouloir supprimer cette source ?',
      confirmationKey: 'SUPPRIMER SOURCE',
      confirmationLabel: 'texte de confirmation',
      buttonText: 'Supprimer',
      successMessage: 'Source supprimée avec succès',
      warningIntro: 'La suppression de cette source supprimera également définitivement :',
      warningRoutes: 'Toutes les routes utilisant cette source',
      warningSourceTables: 'Toutes les tables source associées à cette source',
      warningWebhooks: 'Tous les abonnements webhook associés à cette source',
      baseUrl: 'URL de base :',
    },
    deleteTarget: {
      title: 'Supprimer la cible',
      description: 'Êtes-vous sûr de vouloir supprimer cette cible ?',
      buttonText: 'Supprimer la cible',
      cancel: 'Annuler',
      deleting: 'Suppression...',
      successMessage: 'Cible supprimée avec succès',
      warning: 'Attention : Cette action ne peut pas être annulée.',
      warningDescription: 'La suppression de cette cible supprimera également définitivement :',
      warningRoutes: 'Toutes les routes utilisant cette cible',
      server: 'Serveur :',
      database: 'Base de données :',
    },
    deleteSchedule: {
      title: 'Supprimer le planning',
      description:
        'Êtes-vous sûr de vouloir supprimer ce planning de temps calme ? Cette action ne peut pas être annulée.',
      cancel: 'Annuler',
      delete: 'Supprimer',
      successMessage: 'Planning supprimé avec succès',
      errorMessage: 'Échec de la suppression du planning',
    },
    confirmDelete: {
      warning: 'ATTENTION :',
      defaultWarning: 'Cette action ne peut pas être annulée.',
      typeToConfirm: 'Tapez ce qui suit pour confirmer :',
      enterPrefix: 'Entrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      deleting: 'Suppression...',
    },
    newOrganization: {
      title: 'Créer une nouvelle organisation',
      description:
        'Entrez un nom pour votre nouvelle organisation. Vous pourrez le modifier plus tard dans les paramètres.',
      organizationName: "Nom de l'organisation",
      organizationNamePlaceholder: 'Mon organisation',
      billingCountry: 'Pays de facturation',
      billingCountryDescription: 'Sélectionnez le pays pour la facturation. Cela ne peut pas être modifié ultérieurement.',
      billingCountryPlaceholder: 'Sélectionner un pays',
      billingCountrySearch: 'Rechercher des pays...',
      billingCountryNoResults: 'Aucun pays trouvé.',
      cancel: 'Annuler',
      create: 'Créer',
      organizationCreatedSuccessfully: 'Organisation créée avec succès !',
    },
    setBillingCountry: {
      title: 'Définir le pays de facturation',
      description: 'Veuillez sélectionner un pays de facturation pour votre organisation. Cela est requis pour continuer.',
      billingCountry: 'Pays de facturation',
      billingCountryRequired: 'Un pays de facturation est requis',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      billingCountryUpdated: 'Pays de facturation mis à jour avec succès !',
    },
    inviteUser: {
      title: 'Inviter un nouvel utilisateur',
      description:
        'Envoyer une invitation à un nouvel utilisateur pour rejoindre votre organisation',
      email: 'E-mail',
      emailPlaceholder: 'jean.dupont@exemple.com',
      role: 'Rôle',
      rolePlaceholder: 'Sélectionner un rôle',
      roleReader: 'Lecteur',
      roleOperator: 'Opérateur',
      roleAdministrator: 'Administrateur',
      roleBillingManager: 'Gestionnaire de facturation',
      roleExpiration: "Date d'expiration du rôle (Optionnel)",
      roleExpirationPlaceholder: 'Choisir une date',
      roleExpiresOn: "Le rôle de l'utilisateur expirera le {date}",
      invitationExpiresNote: "Note : L'invitation expirera automatiquement 7 jours après son envoi",
      cancel: 'Annuler',
      sending: 'Envoi...',
      sendInvite: "Envoyer l'invitation",
      userInvitedSuccessfully: 'Utilisateur invité avec succès !',
    },
    editUserRole: {
      title: 'Modifier le rôle utilisateur',
      description: 'Modifier le rôle de {email}',
      roleLabel: 'Rôle',
      rolePlaceholder: 'Sélectionnez un nouveau rôle',
      membershipExpiration: "Date d'expiration de l'adhésion (Optionnel)",
      membershipExpirationIndefinite: 'Indéfinie',
      membershipExpiresOn: "L'adhésion expirera le {date}",
      clearExpiration: 'Effacer',
      cancel: 'Annuler',
      update: 'Mettre à jour le rôle',
      updating: 'Mise à jour...',
      triggerLabel: "Modifier le rôle de l'utilisateur",
      roleUpdated: 'Rôle mis à jour avec succès',
    },
    removeMember: {
      title: "Retirer l'utilisateur",
      description: 'Voulez-vous vraiment retirer {email} de cette organisation ?',
      cancel: 'Annuler',
      remove: "Retirer l'utilisateur",
      removing: 'Retrait...',
      triggerLabel: "Retirer l'utilisateur de l'organisation",
      userRemoved: "Utilisateur retiré de l'organisation",
    },
    reinviteUser: {
      title: "Réinviter l'utilisateur",
      description: 'Envoyer une nouvelle invitation à {email}',
      emailLabel: 'E-mail',
      roleLabel: 'Rôle',
      rolePlaceholder: 'Sélectionner un rôle',
      membershipExpiration: "Date d'expiration de l'adhésion (Optionnel)",
      membershipExpirationIndefinite: 'Indéfinie',
      membershipExpiresOn: "L'adhésion expirera le {date}",
      clearExpiration: 'Effacer',
      invitationExpiresNote: "Note : L'invitation expirera automatiquement 7 jours après son envoi",
      cancel: 'Annuler',
      sending: 'Envoi...',
      sendInvitation: "Envoyer l'invitation",
      triggerLabel: "Réinviter l'utilisateur",
      invitationSent: 'Invitation envoyée avec succès',
    },
    acceptInvitation: {
      title: "Invitation à l'organisation",
      description: 'Vous avez été invité à rejoindre une organisation',
      organization: 'Organisation :',
      role: 'Rôle :',
      expiresOn: 'Cette invitation expire le {date}',
      question: "Souhaitez-vous accepter cette invitation et rejoindre l'organisation ?",
      decline: 'Refuser',
      accept: "Accepter l'invitation",
      processing: 'Traitement...',
    },
    redeemTrial: {
      title: "Utiliser l'essai",
      description: "Utiliser un code d'essai pour {orgName}",
      organization: 'Organisation',
      trialCode: "Code d'essai",
      trialCodePlaceholder: "Code d'essai de 32 caractères",
      trialCodeRequired: "Le code d'essai est requis",
      trialCodeInvalid: "Le code d'essai doit contenir 32 caractères alphanumériques",
      cancel: 'Annuler',
      redeeming: 'Utilisation...',
      redeem: 'Utiliser',
      trialRedeemedSuccessfully: 'Essai utilisé avec succès',
      noOrganizationSelected: 'Aucune organisation sélectionnée',
      failedToRedeemTrial: "Échec de l'utilisation de l'essai.",
    },
    syncConfirmation: {
      titleFull: 'Synchronisation complète',
      titleReset: 'Réinitialiser et synchronisation complète',
      descriptionFull: "Vous êtes sur le point d'effectuer une synchronisation complète.",
      descriptionReset:
        "Vous êtes sur le point d'effectuer une opération de réinitialisation destructive et de synchronisation complète.",
      warningReset:
        "Avertissement : Il s'agit d'une action destructive et les données seront temporairement indisponibles.",
      warningResetOperations: 'Cette opération va :',
      warningResetOperation1: 'Supprimer les données existantes dans la cible',
      warningResetOperation2: 'Effectuer une synchronisation complète depuis la source',
      warningResetOperation3: 'Peut causer une indisponibilité temporaire des données',
      warningFull: 'Cela synchronisera toutes les données de la source.',
      warningFullDescription:
        "Une synchronisation complète traite tous les enregistrements de la source, qu'ils aient été synchronisés auparavant ou non. Cela peut prendre plus de temps qu'une synchronisation incrémentale et consommer plus de ressources.",
      acknowledgeReset:
        "Je comprends que cela supprimera toutes les données existantes et réinitialisera l'état de synchronisation. Je souhaite procéder à la réinitialisation et à la synchronisation complète.",
      cancel: 'Annuler',
      syncing: 'Synchronisation...',
      startFullSync: 'Démarrer la synchronisation complète',
      resetAndSync: 'Réinitialiser et synchroniser',
    },
    deleteSourceTable: {
      buttonText: 'Supprimer la table source',
      title: 'Supprimer la table source',
      description: "La suppression d'une table source arrête les synchronisations futures.",
      confirmationLabel: 'nom de la table',
      sourceTableDeletedSuccessfully: 'Table source supprimée avec succès',
    },
    agreementAcceptance: {
      title: 'Accord juridique',
      description:
        "Veuillez lire et accepter l'accord pour continuer.",
      loading: 'Chargement...',
      loadError: 'Impossible de charger le contrat. Veuillez réessayer plus tard.',
      accept: 'Accepter',
      accepting: 'Acceptation...',
      decline: 'Refuser',
      declining: 'Refus...',
      acceptError: "Impossible d'accepter le contrat. Veuillez réessayer.",
      privacyPolicyTitle: 'Politique de confidentialité',
      termsOfUseTitle: "Conditions d'utilisation",
      scrollToAccept: 'Faites défiler vers le bas pour accepter',
    },
  },
  allRuns: {
    title: 'Toutes les exécutions',
    description: 'Afficher toutes les synchronisations de tous les profils de votre organisation',
    noOrganization: 'Aucune organisation sélectionnée',
    runHistory: 'Historique des exécutions',
    filteredResults: 'Résultats filtrés',
    filtersActive: 'filtres actifs',
    filter: 'filtre',
    allSyncRuns: 'Toutes les synchronisations de tous les profils',
    noRunsFound: 'Aucune synchronisation trouvée.',
    refresh: 'Actualiser',
    liveUpdates: {
      label: 'Mises à jour en direct',
      tooltip:
        'Actualiser automatiquement les données toutes les 5 secondes. Se désactive automatiquement après 5 minutes.',
      autoDisabledMessage:
        'Les mises à jour en direct ont été automatiquement désactivées après 5 minutes.',
      reenableButton: 'Réactiver',
    },
    showSkipped: {
      label: 'Afficher les ignorées',
      tooltip: "Les exécutions ignorées sont masquées par défaut. Activez cette option pour les inclure dans la liste.",
    },
    table: {
      runId: "ID d'exécution",
      profile: 'Profil',
      sourceTable: 'Table source',
      scheduled: 'Planifié',
      started: 'Commencé',
      completed: 'Terminé',
      state: 'État',
      duration: 'Durée',
      extractionStarted: 'Extraction commencée',
      extractionCompleted: 'Extraction terminée',
      extractionDuration: "Durée d'extraction",
      loadStarted: 'Chargement commencé',
      loadCompleted: 'Chargement terminé',
      loadDuration: 'Durée de chargement',
      rowsExtracted: 'Lignes extraites',
      rowsLoaded: 'Lignes chargées',
      rowsInserted: 'Lignes insérées',
      rowsUpdated: 'Lignes mises à jour',
      rowsDeleted: 'Lignes supprimées',
      rows: 'lignes',
      progress: 'Progression',
      syncMode: 'Mode de synchronisation',
      triggerSource: 'Déclencheur',
      region: 'Région',
      schemaChanges: 'Changements de schéma',
      actions: 'Actions',
    },
    schemaChanges: {
      title: 'Changements de schéma',
      columnsCreated: 'Colonnes créées',
      columnsWidened: 'Élargissement de colonnes',
      failedMigrations: 'Migrations échouées',
      columnName: 'Colonne',
      sqlType: 'Type SQL',
      entity: 'Entité',
      fromType: 'De',
      toType: 'À',
      noChanges: 'Aucun changement de schéma enregistré pour cette exécution.',
      viewChanges: 'Voir {0} modifications',
    },
    actions: {
      cancel: 'Annuler',
      cancelSuccess: 'Exécution annulée avec succès',
      cancelError: "Échec de l'annulation de l'exécution",
      copiedToClipboard: 'Copié dans le presse-papiers',
      failedToCopy: 'Échec de la copie',
    },
    columnToggle: {
      columnsButton: 'Colonnes',
      toggleColumnsLabel: 'Basculer les colonnes',
      showAllColumns: 'Afficher toutes les colonnes',
      extractionSection: 'Extraction',
      loadSection: 'Chargement',
      rows: 'Lignes',
    },
    pagination: {
      page: 'Page',
      showing: 'Affichage',
      runs: 'exécutions',
      previous: 'Précédent',
      next: 'Suivant',
    },
    errors: {
      failedToLoad: 'Échec du chargement des exécutions',
    },
    filters: {
      filterButton: 'Filtrer',
      profile: 'Profil',
      runState: "État d'exécution",
      sourceTable: 'Table source',
      noProfilesAvailable: 'Aucun profil disponible',
      noSourceTablesAvailable: 'Aucune table source disponible',
      customSourceTable: 'Entrez le nom de la table...',
      clearAll: 'Tout effacer',
      unknownProfile: 'Profil inconnu',
    },
  },
  help: {
    title: 'Aide',
    description: "Obtenez de l'aide et trouvez des ressources utiles",
    additionalResources: {
      title: 'Ressources supplémentaires',
      description:
        "Trouvez de la documentation, des guides et des tutoriels sur notre site d'assistance",
      content: "Trouvez des ressources supplémentaires sur le site d'assistance",
      comingSoon: '(bientôt disponible)',
    },
    chatWithSupport: {
      title: "Discuter avec l'assistance",
      description: "Obtenez de l'aide directement de notre équipe d'assistance",
      comingSoon: 'Bientôt disponible',
    },
  },
  billing: {
    title: 'Facturation',
    description: 'Gérez votre abonnement et vos droits',
    redeemTrialCode: "Échanger un code d'essai",
    subscribe: "S'abonner",
    customerPortal: 'Portail client',
    manageSubscription: 'Gérer la facturation',
    customerPortalTooltip: "Mettre à jour l'abonnement, consulter les factures et modifier les méthodes de paiement.",
    entitlementsTable: {
      title: 'Droits',
      type: 'Type',
      ruleType: 'Type de règle',
      profiles: 'Profils',
      status: 'Statut',
      expirationDate: 'Date de fin',
      noEntitlements: 'Aucun droit trouvé.',
      trial: 'Essai',
      paid: 'Abonnement',
      default: 'Par défaut',
      active: 'Actif',
      expired: 'Expiré',
      pastDue: 'En retard',
      renewal: 'Renouvellement',
      enabled: 'Activé',
      disabled: 'Désactivé',
      never: 'Jamais',
      renewsOn: 'Renouvellement le {date}',
      expiresOn: 'Expire le {date}',
      neverExpires: "N'expire jamais",
      ruleTypes: {
        minimum: 'Minimum',
        minimumTooltip: 'Ce droit accorde au moins {value} profils actifs.',
        cumulative: 'Cumulatif',
        cumulativeTooltip: 'Ce droit accorde {value} profils actifs supplémentaires.',
      },
    },
    pastDueAlert: {
      title: 'Paiement requis',
      alertTitle: 'Paiement en retard',
      description: 'Le paiement de votre abonnement est en retard. Veuillez mettre à jour votre mode de paiement pour éviter une interruption de service.',
    },
    trialExpirationAlert: {
      alertTitle: "Essai bientôt terminé",
      description: "Votre essai expire dans {days} jours. Abonnez-vous maintenant pour continuer à utiliser toutes les fonctionnalités.",
    },
    noEntitlementsAlert: {
      alertTitle: 'Abonnement requis',
      description: 'Vous avez besoin d\'un abonnement actif pour synchroniser les profils. Abonnez-vous maintenant pour continuer.',
    },
    planPicker: {
      title: 'Choisissez un plan',
      description:
        "Sélectionnez la formule d'abonnement souhaitée. Vous serez redirigé vers notre prestataire de paiement pour finaliser l'achat.",
      quantity: 'Quantité',
      total: 'Total',
      perMonth: '/mois',
      perYear: '/an',
      savePercent: 'Économisez {percent}%',
      failedToLoad: 'Échec du chargement des plans disponibles',
      noPlans: "Aucun plan n'est actuellement disponible pour votre organisation.",
      planUnavailable:
        "Le plan sélectionné n'est plus disponible pour votre organisation. Les plans disponibles ont été actualisés.",
      checkoutError: 'Échec du démarrage du paiement. Veuillez réessayer.',
    },
    invoiceHistory: {
      title: 'Factures',
      date: 'Date',
      amount: 'Montant',
      statusLabel: 'Statut',
      actions: 'Actions',
      noInvoices: 'Aucune facture trouvée.',
      view: 'Voir',
      showing: 'Affichage de {count} sur {total} factures',
      previous: 'Précédent',
      next: 'Suivant',
      status: {
        draft: 'Brouillon',
        open: 'Ouverte',
        paid: 'Payée',
        uncollectible: 'Irrécouvrable',
        void: 'Annulée',
        unknown: 'Inconnu',
      },
    },
    orgBilling: {
      title: 'Informations de facturation',
      billingAddress: 'Adresse de facturation',
      paymentMethod: 'Moyen de paiement',
      noAddress: 'Aucune adresse de facturation enregistrée',
      noPaymentMethod: 'Aucun moyen de paiement enregistré',
      expires: 'Expire',
      failedToLoad: 'Échec du chargement des informations de facturation',
      paymentMethodTypes: {
        card: 'Carte',
        acss_debit: 'Prélèvement préautorisé (ACSS)',
        affirm: 'Affirm',
        afterpay_clearpay: 'Afterpay / Clearpay',
        alipay: 'Alipay',
        alma: 'Alma',
        amazon_pay: 'Amazon Pay',
        au_becs_debit: 'Prélèvement BECS (AU)',
        bacs_debit: 'Prélèvement Bacs',
        bancontact: 'Bancontact',
        billie: 'Billie',
        blik: 'BLIK',
        boleto: 'Boleto',
        card_present: 'Carte (en personne)',
        cashapp: 'Cash App Pay',
        crypto: 'Crypto',
        customer_balance: 'Solde du compte',
        eps: 'EPS',
        fpx: 'FPX',
        giropay: 'giropay',
        grabpay: 'GrabPay',
        ideal: 'iDEAL',
        interac_present: 'Interac',
        kakao_pay: 'Kakao Pay',
        klarna: 'Klarna',
        konbini: 'Konbini',
        kr_card: 'Carte coréenne',
        link: 'Link',
        mb_way: 'MB WAY',
        mobilepay: 'MobilePay',
        multibanco: 'Multibanco',
        naver_pay: 'Naver Pay',
        nz_bank_account: 'Compte bancaire NZ',
        oxxo: 'OXXO',
        p24: 'Przelewy24',
        pay_by_bank: 'Payer par banque',
        payco: 'PAYCO',
        paynow: 'PayNow',
        paypal: 'PayPal',
        paypay: 'PayPay',
        payto: 'PayTo',
        pix: 'Pix',
        promptpay: 'PromptPay',
        revolut_pay: 'Revolut Pay',
        samsung_pay: 'Samsung Pay',
        satispay: 'Satispay',
        sepa_debit: 'Prélèvement SEPA',
        sofort: 'Sofort',
        swish: 'Swish',
        twint: 'TWINT',
        us_bank_account: 'Compte bancaire US',
        wechat_pay: 'WeChat Pay',
        zip: 'Zip',
        unknown: 'Moyen de paiement',
      },
    },
    manageAddOns: {
      title: 'Gérer les modules',
      description: 'Modifier les modules de votre abonnement',
      button: 'Gérer les modules',
      currentAddOns: 'Modules actuels',
      availableAddOns: 'Modules disponibles',
      noCurrentAddOns: 'Vous n\'avez aucun module actif',
      noAvailableAddOns: 'Aucun module supplémentaire disponible',
      add: 'Ajouter',
      remove: 'Supprimer',
      perMonth: '/mois',
      perYear: '/an',
      previewChanges: 'Aperçu des modifications',
      confirmChanges: 'Confirmer les modifications',
      back: 'Retour',
      noChanges: 'Aucune modification à prévisualiser',
      preview: {
        title: 'Vérifier les modifications',
        description: 'Vérifiez l\'impact de vos modifications d\'abonnement',
        changesSummary: 'Résumé des modifications',
        dueToday: 'À payer aujourd\'hui',
        dueTodayDescription: 'Frais au prorata pour la période de facturation en cours',
        nextRenewal: 'Prochain renouvellement',
        nextRenewalDescription: 'Vos nouveaux frais récurrents',
        effectiveDate: 'Date d\'effet',
        immediateCharge: 'Frais immédiats',
        newRecurringTotal: 'Nouveau total récurrent',
        wasQuantity: '(était {quantity})',
        newItem: '(nouveau)',
        removed: '(supprimé)',
      },
      success: 'Modules mis à jour avec succès',
      errorPreview: 'Échec de l\'aperçu des modifications',
      errorUpdate: 'Échec de la mise à jour des modules',
      pendingChanges: 'La réduction en attente prendra effet le {date}',
      cancellationScheduled: 'Votre abonnement est programmé pour annulation. Les modules ne peuvent pas être modifiés.',
    },
  },
  agents: {
    title: 'Agents',
    description: 'Gérer les agents auto-hébergés pour votre organisation',
    addAgent: 'Ajouter un agent',
    loadingAgents: 'Chargement des agents...',
    noAgentsFound: 'Aucun agent trouvé. Ajoutez un agent pour commencer.',
    table: {
      name: 'Nom',
      status: 'Statut',
      version: 'Version',
      lastHeartbeat: 'Dernier signal',
      registeredAt: 'Enregistré le',
      created: 'Créé',
      actions: 'Actions',
      lastError: 'Dernière erreur',
      viewDetails: 'Voir les détails',
    },
    detailPage: {
      title: "Détails de l'agent",
      backButton: 'Retour aux agents',
      infoCard: {
        title: "Informations sur l'agent",
        status: 'Statut',
        version: 'Version',
        lastHeartbeat: 'Dernier signal',
        registeredAt: 'Enregistré le',
        lastError: 'Dernière erreur',
        noError: 'Aucune',
      },
      logs: {
        title: "Journaux de l'agent",
        level: 'Niveau',
        source: 'Source',
        message: 'Message',
        timestamp: 'Reçu à',
        agentTime: 'Agent :',
        noLogs: 'Aucun journal enregistré.',
        loadMore: 'Charger plus',
        loading: 'Chargement des journaux...',
        error: 'Échec du chargement des journaux',
        showing: '{count} entrées affichées',
      },
    },
    status: {
      Active: 'Actif',
      Inactive: 'Inactif',
      Unregistered: 'Non enregistré',
    },
    createDialog: {
      title: 'Ajouter un agent',
      description: 'Créer un nouvel agent auto-hébergé pour votre organisation',
      nameLabel: "Nom de l'agent",
      namePlaceholder: 'Mon agent',
      cancel: 'Annuler',
      create: 'Créer un agent',
      creating: 'Création...',
      successTitle: 'Agent créé',
      successDescription: "Votre agent a été créé. Copiez le jeton d'inscription ci-dessous. Ce jeton ne sera affiché qu'une seule fois.",
      registrationToken: "Jeton d'inscription",
      tokenExpires: "Le jeton expire le",
      copyToken: 'Copier le jeton',
      tokenCopied: 'Jeton copié dans le presse-papiers',
      tokenWarning: "Ce jeton ne sera affiché qu'une seule fois. Assurez-vous de le copier maintenant.",
      close: 'Fermer',
    },
    editDialog: {
      title: "Modifier l'agent",
      description: "Modifier le nom de l'agent et les tâches parallèles",
      nameLabel: "Nom de l'agent",
      namePlaceholder: 'Mon agent',
      cancel: 'Annuler',
      save: 'Enregistrer les modifications',
      saving: 'Enregistrement...',
      success: 'Agent mis à jour avec succès',
      triggerLabel: "Modifier l'agent",
      workerCountLabel: 'Tâches parallèles',
      workerCountDescription: "Nombre de tâches que l'agent exécute en même temps (1–10). Appliqué au prochain signal de l'agent. Par défaut 4.",
      workerCountRange: 'Les tâches parallèles doivent être un nombre entier entre 1 et 10',
    },
    deleteDialog: {
      title: "Supprimer l'agent",
      description: 'Êtes-vous sûr de vouloir supprimer l\'agent "{name}" ? Cette action est irréversible.',
      cancel: 'Annuler',
      delete: "Supprimer l'agent",
      deleting: 'Suppression...',
      success: 'Agent supprimé avec succès',
      triggerLabel: "Supprimer l'agent",
    },
    regenerateTokenDialog: {
      title: "Régénérer le jeton d'inscription",
      description: 'Générer un nouveau jeton d\'inscription pour l\'agent "{name}". Le jeton précédent sera invalidé.',
      cancel: 'Annuler',
      regenerate: 'Régénérer le jeton',
      regenerating: 'Régénération...',
      registrationToken: "Jeton d'inscription",
      tokenExpires: "Le jeton expire le",
      copyToken: 'Copier le jeton',
      tokenCopied: 'Jeton copié dans le presse-papiers',
      tokenWarning: "Ce jeton ne sera affiché qu'une seule fois. Assurez-vous de le copier maintenant.",
      close: 'Fermer',
      triggerLabel: "Régénérer le jeton d'inscription",
    },
    toggleStatus: {
      activate: 'Activer',
      deactivate: 'Désactiver',
      activated: 'Agent activé avec succès',
      deactivated: 'Agent désactivé avec succès',
    },
    relativeTime: {
      justNow: "À l'instant",
      minutesAgo: 'il y a {count}m',
      hoursAgo: 'il y a {count}h',
      daysAgo: 'il y a {count}j',
      never: 'Jamais',
    },
    downloadLatest: 'Télécharger le dernier agent',
    updateAvailable: 'Mise à jour de l\'agent disponible',
    updateAvailableDescription: 'Les agents suivants utilisent une version obsolète et doivent être mis à jour :',
    versionOutdated: 'Mise à jour disponible',
    profileAgentOutdated: 'L\'agent associé à ce profil utilise une version obsolète. Veuillez effectuer la mise à jour vers la dernière version.',
    assignedAgent: 'Agent assigné',
    agentDisabled: 'Agent désactivé',
    agentDisabledDescription: 'Cet agent est désactivé. Les tâches planifiées seront mises en file d\'attente et traitées lorsque l\'agent sera réactivé.',
    health: {
      label: 'Santé',
      Online: 'En ligne',
      Suspect: 'Vérification',
      Offline: 'Hors ligne',
      offlineSince: 'Hors ligne depuis {time}',
    },
    healthCheck: {
      confirm: "Vérifier l'état",
      started: "Vérification de l'état lancée",
      checking: 'Vérification…',
      potentialIssue: 'Problème potentiel',
      likelyIssue: 'Problème probable',
      healthy: 'En bonne santé',
      busy: "Occupé – vérification en file d'attente derrière une tâche en cours",
      unresponsive: 'Aucune réponse – marqué hors ligne',
      inconclusive: "La vérification n'a pas pu être effectuée",
      lastResult: "Dernière vérification de l'état",
    },
    agentOffline: {
      title: 'Synchronisations suspendues – agent hors ligne',
      profileDescription: "L'agent « {agent} » qui charge la cible de ce profil est hors ligne depuis {time}. Rien n'est synchronisé jusqu'à son retour en ligne ; les synchronisations reprennent automatiquement.",
      dashboardDescription: "{count} agent(s) hors ligne. Les profils qui les utilisent sont suspendus jusqu'à leur retour en ligne.",
      viewAgents: 'Voir les agents',
    },
    errors: {
      failedToLoadAgents: 'Échec du chargement des agents',
    },
  },
  organizationMembers: {
    title: "Membres de l'organisation",
    description: 'Gérer les membres et leurs rôles dans votre organisation',
    inviteNewUser: 'Inviter un nouvel utilisateur',
    loadingMembers: 'Chargement des membres...',
    noMembersFound: 'Aucun membre trouvé. Invitez des utilisateurs pour commencer.',
    organizationNotFound: 'Organisation introuvable',
    table: {
      email: 'E-mail',
      role: 'Rôle',
      status: 'Statut',
      joined: 'Rejoint',
      expires: 'Expire',
      actions: 'Actions',
    },
    roles: {
      Administrator: 'Administrateur',
      Operator: 'Opérateur',
      Reader: 'Lecteur',
      Billing: 'Gestionnaire de facturation',
    },
    status: {
      Accepted: 'Accepté',
      Invited: 'Invité',
      Declined: 'Refusé',
      Expired: 'Expiré',
    },
    indefinite: 'Indéfinie',
  },
  userContext: {
    noAccount: 'Aucun compte disponible',
    authRequired: 'Authentification interactive requise',
    initFailed: "Échec de l'initialisation de l'utilisateur",
    loading: 'Chargement...',
    mustUseProvider: 'useUser doit être utilisé dans un UserProvider',
  },
  authenticationError: {
    title: 'Authentification requise',
    description:
      "Votre session a expiré ou l'authentification a échoué. Veuillez vous reconnecter pour continuer.",
    signInButton: 'Se connecter à nouveau',
  },
  errors: {
    common: {
      title: 'Erreur de chargement des données',
      retry: 'Réessayer',
      failedToLoad: 'Échec du chargement des données',
      networkError: 'Erreur réseau - veuillez vérifier votre connexion',
      serverError: 'Erreur serveur - veuillez réessayer plus tard',
      unauthorized: 'Authentification requise - veuillez vous reconnecter',
      forbidden: 'Accès refusé - autorisations insuffisantes',
      notFound: 'Ressource introuvable',
      unknown: "Une erreur inattendue s'est produite",
    },
    profiles: {
      failedToLoadProfiles: 'Échec du chargement des profils',
      failedToLoadProfileDetails: 'Échec du chargement des détails du profil',
      failedToLoadSchedules: 'Échec du chargement des planifications',
      failedToLoadSourceTables: 'Échec du chargement des tables sources',
      failedToLoadRuns: 'Échec du chargement des exécutions de synchronisation',
    },
    entitlements: {
      failedToLoadEntitlements: "Échec du chargement des informations d'abonnement",
    },
    members: {
      failedToLoadRoles: "Échec du chargement des rôles de l'organisation",
      failedToLoadMembers: "Échec du chargement des membres de l'organisation",
    },
    codes: {
      Success: 'L\'opération de synchronisation s\'est terminée avec succès.',
      BadRequest: 'La demande était invalide ou malformée. Veuillez vérifier vos paramètres de configuration et réessayer.',
      Unauthorized: 'L\'authentification est requise pour effectuer cette opération. Veuillez vous reconnecter ou vérifier vos identifiants.',
      Forbidden: 'Vous n\'avez pas la permission d\'effectuer cette opération. Veuillez contacter votre administrateur pour demander l\'accès.',
      NotFound: 'La ressource demandée n\'a pas pu être trouvée. Vérifiez que le profil, la source ou la cible existe toujours.',
      Conflict: 'Cette opération entre en conflit avec une ressource existante. Une autre synchronisation peut être en cours ou la ressource existe déjà.',
      InternalServerError: 'Une erreur serveur inattendue s\'est produite. Veuillez réessayer plus tard. Si le problème persiste, contactez le support.',
      DatabaseError: 'Une opération de base de données a échoué. Veuillez vérifier votre configuration de base de données et réessayer.',
      ServiceUnavailable: 'Le service est temporairement indisponible. Veuillez attendre quelques minutes et réessayer.',
      DataExtractionFailed: 'Impossible d\'extraire les données de la source. Vérifiez les paramètres de connexion à la source et que le service principal a accès en lecture à l\'entité Dataverse.',
      SchemaExtractionFailed: 'Impossible d\'extraire les informations du schéma de la source. Vérifiez que le service principal a la permission de lire les métadonnées d\'entité dans Dataverse.',
      CheckpointRetrievalFailed: 'Impossible de récupérer les informations du point de contrôle de synchronisation. L\'état de la synchronisation peut être corrompu. Essayez d\'effectuer une Reset & Full Sync pour restaurer l\'état de la synchronisation.',
      TargetLoadFailed: 'Impossible de charger les données dans la base de données cible. Vérifiez les paramètres de connexion à la cible et que le service principal a des permissions d\'écriture sur le schéma cible.',
      DataTransformationFailed: 'Impossible de transformer les données pendant la synchronisation. Les données source peuvent contenir des valeurs incompatibles avec le schéma cible. Vérifiez le message d\'erreur externe pour plus de détails.',
      SourceConnectionFailed: 'Impossible de se connecter à la source Dataverse. Vérifiez que l\'URL de base, le Client ID et le Client Secret sont corrects et que l\'application est enregistrée dans le bon tenant.',
      TargetConnectionFailed: 'Impossible de se connecter à la cible Azure SQL. Vérifiez le nom du serveur, le nom de la base de données et les identifiants. Assurez-vous que le pare-feu autorise les connexions à partir des services Azure.',
      RateLimitExceeded: 'La limite de débit de l\'API Dataverse a été dépassée. La synchronisation réessayera automatiquement. Si cela persiste, envisagez de réduire la fréquence de synchronisation ou de contacter le support Microsoft.',
      TimeoutError: 'L\'opération a expiré avant de se terminer. Cela peut indiquer des problèmes réseau ou une réponse lente du système source ou cible.',
      NetworkError: 'Une erreur réseau s\'est produite. Veuillez vérifier votre connexion Internet et confirmer que les points de terminaison source et cible sont accessibles.',
      OrchestrationTimeout: 'L\'opération de synchronisation a dépassé le temps d\'exécution maximal autorisé. Pour les grands volumes de données, envisagez de synchroniser moins de tables ou d\'effectuer une synchronisation initiale pendant les heures creuses.',
      OrchestrationCancelled: 'La synchronisation a été annulée, manuellement ou parce que le profil ou l\'entité associé a été supprimé.',
      OrchestrationOrphaned: 'L\'opération de synchronisation a été interrompue de manière inattendue avant de pouvoir se terminer. Veuillez réessayer la synchronisation.',
      InvalidConfiguration: 'La configuration du profil est invalide. Veuillez vérifier vos paramètres de source, de cible et de table pour vous assurer qu\'ils sont complets et corrects.',
      TargetInitialSyncConflict: 'La table cible contient déjà des données d\'une synchronisation précédente. Supprimez les données existantes de la table cible ou utilisez Reset & Full Sync pour recommencer à zéro.',
      DataverseCallFailed: 'Un appel à l\'API Dataverse a échoué de manière inattendue. Vérifiez le message d\'erreur externe pour plus de détails. Si le problème persiste, vérifiez que votre environnement Dataverse fonctionne correctement.',
      DataverseAuthenticationFailed: 'L\'authentification à Dataverse a échoué. Vérifiez que le Client ID et le Client Secret sont corrects, que le secret n\'a pas expiré et que l\'application est enregistrée dans le tenant Dataverse.',
      DataverseChangeTrackingNotEnabled: 'Le suivi des modifications n\'est pas activé pour cette entité Dataverse. Activez le suivi des modifications dans le centre d\'administration Dataverse pour permettre les synchronisations incrémentielles.',
      DataverseEntityNotFound: 'L\'entité Dataverse n\'a pas été trouvée. Vérifiez que le nom logique de l\'entité est correct et que l\'entité existe dans votre environnement Dataverse.',
      DataversePermissionDenied: 'Le service principal n\'a pas la permission d\'accéder à cette entité Dataverse. Accordez les rôles de sécurité appropriés à l\'application dans le centre d\'administration Dataverse.',
      DataverseInvalidEntityConfiguration: 'La configuration de l\'entité Dataverse est invalide. L\'entité peut manquer une clé primaire ou avoir une structure non prise en charge.',
      DataverseSecretRetrievalFailed: 'Impossible de récupérer les identifiants à partir du magasin sécurisé. Veuillez réentrer votre Client Secret dans la configuration de la source.',
      LockAcquisitionFailed: 'Impossible d\'acquérir un verrou sur la base de données cible. Une autre synchronisation peut être en cours. Attendez que la synchronisation en cours se termine avant de réessayer.',
      AzureSqlAuthenticationFailed: 'L\'authentification à Azure SQL a échoué. Vérifiez que le Tenant ID, le Client ID et le Client Secret sont corrects. Assurez-vous que le service principal est ajouté en tant qu\'utilisateur de base de données avec les permissions appropriées.',
      AzureSqlConnectionTimeout: 'La connexion à Azure SQL a expiré. Le serveur de base de données peut être inaccessible, suspendu ou en surcharge. Vérifiez le statut du serveur dans le portail Azure.',
      AzureSqlPermissionDenied: 'Le service principal n\'a pas les permissions suffisantes sur la base de données Azure SQL. Accordez les rôles db_datareader et db_datawriter au service principal sur la base de données cible.',
      AzureSqlSchemaMigrationFailed: 'Impossible de créer ou de mettre à jour le schéma de la base de données. Le service principal peut manquer la permission de créer des tables, ou la modification du schéma entre en conflit avec les objets existants.',
      AzureSqlDataImportFailed: 'Impossible d\'importer les données dans Azure SQL. Vérifiez que les types de données sont compatibles et que le service principal a les permissions INSERT sur les tables cibles.',
      AzureSqlMergeFailed: 'L\'opération de fusion des données a échoué. Cela peut être dû à des incompatibilités de types de données, des violations de contraintes ou des erreurs de syntaxe SQL. Vérifiez le message d\'erreur externe pour plus de détails.',
      AzureSqlConstraintViolation: 'Les données violent une contrainte de base de données (clé étrangère, unique ou contrainte de vérification). Les données source peuvent contenir des références invalides ou des clés dupliquées.',
      AzureSqlDeadlock: 'Un blocage a été détecté lors de l\'opération de synchronisation. L\'opération sera réessayée automatiquement. Si cela persiste, envisagez de planifier les synchronisations pendant les heures creuses.',
      AzureSqlDatabaseNotFound: 'La base de données spécifiée n\'a pas été trouvée sur le serveur Azure SQL. Vérifiez que le nom de la base de données est correct et que la base de données n\'a pas été supprimée ou renommée.',
      AzureSqlServerNotFound: 'Le serveur Azure SQL n\'a pas pu être atteint. Vérifiez que le nom du serveur est correct, que le serveur existe et que la connectivité réseau permet la connexion.',
      AzureSqlTransactionTimeout: 'Une transaction de base de données a expiré. L\'opération a pris trop de temps à se terminer, possiblement en raison de contentions de verrous ou de contraintes de ressources. Envisagez d\'augmenter le niveau de service de la base de données.',
      AzureSqlInsufficientResources: 'La base de données Azure SQL a des ressources insuffisantes (CPU, mémoire ou DTUs) pour terminer l\'opération. Envisagez d\'augmenter vers un niveau de service plus élevé.',
      AzureSqlSchemaMetadataNotFound: 'Les métadonnées de schéma requises n\'ont pas été trouvées. Cela peut indiquer un problème d\'état de synchronisation. Essayez d\'effectuer une Reset & Full Sync pour régénérer le schéma.',
      AzureSqlPrimaryKeyStructureChanged: 'La structure de clé primaire de l\'entité source a changé et ne peut pas être appliquée à la table cible existante. Supprimez la table cible ou utilisez Reset & Full Sync.',
      AzureSqlUnsafeSchemaChange: 'La modification du schéma source ne peut pas être appliquée de manière sécurisée. Seul l\'élargissement des types de colonnes et la réduction de la contrainte de colonnes (nullable) sont pris en charge. Les autres modifications nécessitent une Reset & Full Sync.',
      AzureSqlMergeTimeout: 'L\'opération de fusion des données a expiré. Cela se produit généralement lors de la synchronisation de grands volumes de données vers une base de données de bas niveau. Envisagez d\'augmenter le niveau de service de votre base de données ou de réduire le volume de données par synchronisation.',
      AzureSqlFirewallBlocked: 'Connexion bloquée par le pare-feu Azure SQL. Ajoutez l\'IP statique Data Mission ({ip}) à la liste autorisée du pare-feu de votre serveur.',
      AzureSqlSchemaNotFound: 'Le schéma spécifié n\'existe pas dans la base de données cible. Créez le schéma dans Azure SQL ou modifiez le nom du schéma dans votre configuration cible.',
      AgentTaskTimedOut: 'L\'agent auto-hébergé n\'a pas terminé la tâche dans le délai configuré. Vérifiez que l\'agent est en cours d\'exécution et a un accès réseau à la source et à la cible.',
      AgentTaskFailed: 'L\'agent auto-hébergé a signalé un échec de tâche. Assurez-vous que le logiciel de l\'agent est à jour et consultez les journaux de l\'agent pour plus de détails.',
      UnsupportedTaskType: 'L\'agent a reçu un type de tâche qu\'il ne prend pas en charge. Assurez-vous que le logiciel de l\'agent est à jour.',
      AgentTaskNotPickedUp: 'L\'agent auto-hébergé n\'a pas démarré la tâche dans les 10 minutes alors qu\'il n\'était pas occupé par d\'autres travaux. Vérifiez que le service de l\'agent est en cours d\'exécution et connecté.',
      SupportServiceUnavailable: 'L\'assistance est temporairement indisponible. Veuillez réessayer dans quelques minutes.',
      SupportServiceMisconfigured: 'L\'assistance est temporairement indisponible. Veuillez réessayer plus tard ou nous contacter si le problème persiste.',
      // SQL Server numeric error codes
      '40615': 'Votre adresse IP n\'est pas autorisée à se connecter au serveur. Veuillez ajouter cette IP aux règles de pare-feu Azure SQL.',
      '-2': 'Délai d\'attente de connexion. Le serveur peut être inaccessible ou les règles de pare-feu peuvent bloquer l\'accès.',
      '-1': 'Délai d\'attente de connexion. Le serveur peut être inaccessible ou les règles de pare-feu peuvent bloquer l\'accès.',
      '18456': 'Échec de la connexion. Veuillez vérifier que vos identifiants sont corrects et ont accès à la base de données.',
      '4060': 'Impossible d\'accéder à la base de données. Veuillez vérifier que la base de données existe et que le service principal y a accès.',
      '297': 'Le service principal n\'a pas la permission d\'accéder à la base de données.',
      '916': 'Le service principal n\'a pas la permission d\'accéder à la base de données.',
      '53': 'Erreur réseau lors de la connexion au serveur. Le serveur peut être inaccessible ou les règles de pare-feu peuvent bloquer l\'accès.',
      '10054': 'Erreur réseau lors de la connexion au serveur. Le serveur peut être inaccessible ou les règles de pare-feu peuvent bloquer l\'accès.',
      '10060': 'Erreur réseau lors de la connexion au serveur. Le serveur peut être inaccessible ou les règles de pare-feu peuvent bloquer l\'accès.',
      '10061': 'Erreur réseau lors de la connexion au serveur. Le serveur peut être inaccessible ou les règles de pare-feu peuvent bloquer l\'accès.',
      '20': 'L\'instance n\'est pas configurée pour accepter les connexions. Veuillez vérifier le nom du serveur et la connectivité.',
      '1202': 'Échec de la connexion à la cible. Le serveur Azure SQL n\'a pas pu être atteint. Veuillez vérifier vos paramètres de connexion.',
      '1501': 'Échec de l\'authentification. Veuillez vérifier que votre ID locataire, ID client et secret client sont corrects et que le service principal a accès à la base de données.',
      '1502': 'Délai de connexion dépassé. Le serveur Azure SQL peut être inaccessible ou en forte charge.',
      '1503': 'Le service principal n\'a pas les permissions SQL suffisantes pour les opérations de synchronisation. Veuillez accorder les permissions nécessaires.',
      '1509': 'Base de données non trouvée. Veuillez vérifier que le nom de la base de données existe et que le service principal y a accès.',
      '1510': 'Serveur non trouvé ou erreur réseau. Veuillez vérifier le nom du serveur Azure SQL et la connectivité réseau.',
      '1517': 'Connexion bloquée par le pare-feu. Veuillez configurer le pare-feu de votre serveur Azure SQL pour autoriser les services Azure ou ajouter les adresses IP pour Azure Canada Central et la région de votre profil sélectionné.',
      '1518': 'Schéma non trouvé. Le schéma spécifié n\'existe pas dans la base de données. Veuillez vérifier le nom du schéma ou le créer.',
      // Dataverse connection error codes
      DataverseHostnameNotFound: 'Le nom d\'hôte Dataverse n\'a pas pu être résolu. Veuillez vérifier que l\'URL de base est correcte et que l\'organisation existe.',
      DataverseInvalidUrl: 'Format d\'URL d\'organisation Dataverse invalide. Veuillez vérifier que l\'URL de base est une URL HTTPS valide.',
      DataverseInvalidClientId: 'ID client invalide. L\'identifiant d\'application n\'est pas reconnu. Veuillez vérifier votre inscription d\'application Azure AD.',
      DataverseInvalidClientSecret: 'Secret client invalide. Le secret client est incorrect ou a expiré. Veuillez vérifier ou régénérer votre secret client.',
      DataverseInvalidAppRegistration: 'Inscription d\'application invalide. L\'application n\'a pas accès à cette instance Dataverse ou n\'est pas enregistrée dans le locataire.',
      DataverseInvalidTenant: 'Impossible de déterminer le locataire d\'authentification à partir de l\'URL Dataverse. Veuillez vérifier que le format de l\'URL de base est correct.',
      DataverseConnectionFailed: 'Échec de la connexion à l\'instance Dataverse. Veuillez vérifier que l\'URL de base est correcte et que l\'instance est accessible.',
      DataversePermissionDeniedMetadata: 'Permission manquante pour lire les métadonnées d\'entité. Le principal de service ne peut pas récupérer les informations de schéma de Dataverse.',
      DataversePermissionDeniedData: 'Permission manquante pour lire les données d\'entité. Le principal de service ne peut pas lire les enregistrements des entités Dataverse.',
      DataverseVersionStampExpired: 'La table n\'a pas été synchronisée depuis trop longtemps et l\'état de synchronisation incrémentielle a expiré. Un Reset & Full Sync est nécessaire pour reprendre la synchronisation.',
      DataverseInvalidRequest: 'Une erreur s\'est produite lors de la lecture des données depuis Dataverse. Vérifiez le message d\'erreur externe pour plus de détails. Si le problème persiste, vérifiez la configuration de votre entité et les permissions.',
      BcCallFailed: 'Un appel à l\'API Business Central a échoué de manière inattendue. Vérifiez le message d\'erreur externe pour plus de détails. Si le problème persiste, vérifiez que votre environnement Business Central fonctionne correctement.',
      BcAuthenticationFailed: 'L\'authentification à Business Central a échoué. Vérifiez que le Client ID et le Client Secret sont corrects, que le secret n\'a pas expiré et que l\'application est enregistrée dans le bon locataire.',
      BcInvalidClientId: 'ID client invalide. L\'identifiant d\'application n\'est pas reconnu dans Azure AD. Veuillez vérifier votre inscription d\'application.',
      BcInvalidClientSecret: 'Secret client invalide. Le secret client est incorrect ou a expiré. Veuillez vérifier ou régénérer votre secret client.',
      BcEnvironmentNotFound: 'L\'environnement Business Central n\'a pas été trouvé. Vérifiez que le nom de l\'environnement est correct et qu\'il existe dans votre locataire.',
      BcCompanyNotFound: 'La société Business Central n\'a pas été trouvée. Vérifiez que l\'ID ou le nom de la société est correct et que la société existe dans l\'environnement sélectionné.',
      BcPermissionDenied: 'Le service principal n\'a pas la permission d\'accéder à Business Central. Assurez-vous que l\'application dispose des autorisations API requises et qu\'elle est consentie dans le locataire.',
      BcEntityNotFound: 'L\'entité ou la page API Business Central n\'a pas été trouvée. Vérifiez que le nom de l\'entité est correct et que la page API est publiée dans Business Central.',
      BcNotFound: 'Business Central a signalé qu\'une ressource demandée est introuvable, sans préciser si la ressource manquante est l\'environnement, la société, l\'entité ou l\'enregistrement. Consultez les détails de l\'erreur externe pour la requête exacte.',
      BcInvalidRequest: 'Business Central a rejeté la requête. Vérifiez le message d\'erreur externe pour plus de détails sur le champ ou le paramètre invalide.',
      BcTenantUnavailable: 'Le locataire Business Central est actuellement indisponible. L\'environnement peut être en cours de maintenance ou de migration. Veuillez réessayer plus tard.',
      // Codes d'erreur Salesforce
      SalesforceCallFailed:
        'Un appel à l\'API Salesforce a échoué de façon inattendue. Vérifiez les détails de l\'erreur. Si le problème persiste, assurez-vous que votre environnement Salesforce fonctionne correctement.',
      SalesforceAuthenticationFailed:
        'L\'authentification à Salesforce a échoué. Vérifiez l\'URL d\'instance, le Client ID et le Client Secret, ainsi que l\'état actif de la Connected App.',
      SalesforceTokenRequestFailed:
        'Impossible d\'obtenir un jeton d\'accès Salesforce. Vérifiez l\'URL d\'instance et assurez-vous que la Connected App est configurée pour le flux des informations d\'identification client.',
      SalesforceInvalidClientCredentials:
        'Le Client ID ou le Client Secret Salesforce est invalide. Vérifiez la Consumer Key et le Consumer Secret de votre Connected App.',
      SalesforceInstanceUrlInvalid:
        'L\'URL d\'instance Salesforce est invalide ou inaccessible. Vérifiez qu\'il s\'agit d\'une URL Salesforce valide (ex. : https://masociete.my.salesforce.com).',
      SalesforceRateLimitExceeded:
        'La limite de requêtes de l\'API Salesforce a été dépassée. La synchronisation sera automatiquement relancée. Si le problème persiste, réduisez éventuellement la fréquence de synchronisation.',
      SalesforceBulkApiUnavailable:
        'La Bulk API 2.0 Salesforce n\'est pas disponible pour cette organisation. Assurez-vous que la Connected App dispose des portées OAuth requises et que l\'utilisateur possède l\'autorisation système "API Enabled".',
      SalesforceBulkJobFailed:
        'Le traitement de requête en masse Salesforce a échoué. Vérifiez les détails de l\'erreur, que l\'objet est interrogeable et que l\'utilisateur dispose d\'un accès en lecture.',
      SalesforceBulkJobTimedOut:
        'Le traitement de requête en masse Salesforce a expiré. L\'objet peut contenir un très grand volume de données. Réduisez éventuellement le nombre de champs synchronisés.',
      SalesforceEntityNotFound:
        'L\'objet Salesforce (SObject) est introuvable. Vérifiez que le nom d\'API est correct et que l\'objet existe dans votre organisation.',
      SalesforceApiScopeNotGranted:
        'Le jeton Salesforce n\'a pas accès à l\'API. Assurez-vous que la Connected App inclut la portée OAuth "api" et que l\'utilisateur possède l\'autorisation système "API Enabled".',
      SalesforceClientCredentialsNotConfigured:
        'Le flux des informations d\'identification client n\'est pas configuré pour cette Connected App. Dans Salesforce Setup, accédez à App Manager → Modifier les politiques → Flux des informations d\'identification client et assignez un utilisateur.',
      SalesforceClientIdNotRecognized:
        'Le Client ID Salesforce (Consumer Key) n\'est pas reconnu. Vérifiez que l\'URL d\'instance correspond à l\'organisation où la Connected App est installée et que l\'application est active.',
      unknown: 'Une erreur inconnue s\'est produite. Veuillez réessayer ou contacter le support.',
    },
  },
  systemNotices: {
    title: 'Avis système',
    noNotices: 'Aucun avis actif',
    showMore: 'Afficher plus',
    showLess: 'Afficher moins',
    acknowledge: 'Reconnaître',
    acknowledgeForOrg: "Reconnaître pour l'organisation",
    acknowledgedSuccessfully: 'Avis reconnu avec succès',
    noPermissionToAcknowledge: "Vous n'avez pas la permission de reconnaître cet avis",
    failedToLoad: 'Échec du chargement des avis système',
  },
};
